import { fr_countriesTranslation } from 'assets/locale/fr/core/fr_countriesTranslation';

const franceTranslation = {
  ...fr_countriesTranslation,
  // HEADER //////////////////
  // Nav
  'header_nav_dashboard': 'Tableau de bord',
  'header_nav_dashboard_sales': 'Ventes',
  'header_nav_dashboard_stock': 'Action',
  'header_nav_dashboard_prediction': 'Prédiction',
  'header_nav_catalog': 'Catalogue',
  'header_nav_catalog-download': 'Télécharger le catalogue',
  'header_nav_multimedia': 'Multimédia',
  'header_nav_clients': 'Clients',
  'header_sub-nav_view-catalog': 'Voir le catalogue',
  'header_sub-nav_add-product': 'Ajouter un produit',
  'header_sub-nav_all-catalogs': 'Gestion des catalogues',
  'header_update-catalog-references': 'Mettre à jour les références',
  'header_sub-nav_catalog-correlation': 'Corrélation des références',
  'header_sub-nav_catalog-generic': 'Génériques H4R',
  'header_sub-nav_catalog-tarifs': 'Tarifs',
  'header_sub-nav_multimedia-catalog': 'Catalogue multimédia',
  'header_sub-nav_multimedia-catalog-videos': 'Vidéos',
  'header_sub-nav_multimedia-catalog-images': 'Images',
  'header_sub-nav_multimedia-catalog-banners': 'Bannières',
  'header_sub-nav_clients-list': 'Liste des clients',
  'header_sub-nav_add-client': 'Ajouter un client',
  'header_nav_sales': 'Ventes',
  // Notifications
  'header_notifications_empty-notifications': "Il n'y a pas de notifications",
  ////////////////////////////

  // SIGNUP PAGE /////////////
  'signup-page_title': "S'inscrire à :",
  'signup-page_sub-title': 'Inscrivez-vous pour développer votre entreprise',
  'signup-page_button-brand': "S'inscrire en tant que marque",
  'signup-page_button-multibrand': "S'inscrire en tant que multimarque",
  'signup-page_button-brand-wh': "M'inscrire en tant que marque ou multimarque",
  'signup-page_return-to-login': 'Retour à la page de connexion',
  ////////////////////////////

  // ACCOUNT PAGE /////////////
  'profile-page_nav_profile': 'Profil',
  'profile-page_nav_company': "Informations de l'entreprise",
  'profile-page_nav_main-contacts': 'Contacts principaux',
  'profile-page_nav_commercial-info': 'Informations commerciales',
  /////////////////////////////

  // DASHBOARDS //////////
  'dashboard_empty-dashboard': 'Contactez Hub4Retail pour activer ce service.',
  'dashboard_dashboard_error': 'Erreur de chargement du tableau de bord. Si le problème persiste, contactez :',
  //////////////////////////////

  // HELMET ///////////////////
  'signup': "S'inscrire",
  'home': 'Accueil',
  'dashboard': 'Tableau de bord',
  'multimedia': 'Multimédia',
  'multimedia-videos': 'Vidéos multimédias',
  'multimedia-images': 'Images multimédias',
  'multimedia-banners': 'Bannières multimédia',
  'clients': 'Clients',
  'profile': 'Profil',
  'company': "Informations de l'entreprise",
  'main-contacts': 'Contacts principaux',
  'commercial-agents': 'Agents commerciaux',
  'catalog': 'Catalogue',
  'notifications': 'Notifications',
  'commercial-profile': 'Profil Commercial',
  'all-catalogs': 'Tous les catalogues',
  'catalog-correlation': 'Corrélation de références',
  'catalog-generic': 'Génériques H4R',
  'catalog_download': 'Télécharger le catalogue',
  'catalog_update-references': 'Mettre à jour les références',
  'catalog_tarifs': 'Tarifs',
  // Client
  'client_resume': 'Résumé',
  'client_business-info': "Informations sur l'entreprise",
  'client_contacts': 'Contacts',
  'client_brands-sold': 'Marques',
  'client_sale-points': 'Points de vente',
  'client_comercial-info': 'Informations commerciales',
  'helmet_meta': 'Meta',
  'helmet_meta_edit_connection': 'Meta - Modifier la connexion',
  'helmet_meta_edit_map': 'Meta - Modifier la carte',
  /////////////////////////////

  // USERS ///////////////////////
  // Departments
  'users_department_commercial': 'Commercial',
  'users_department_administration': 'Administration',
  'users_department_agent': 'Agent',
  'users_department_owner': 'Propriétaire',
  'users_department_store-manager': 'Responsable de magasin',
  'users_department_logistics': 'Logistique',
  'users_department_marketing': 'Marketing',
  'users_department_others': 'Autres',
  ////////////////////////////////

  // ACCOUNT //////////////////
  'account_profile_title': 'Mon profil',
  'account-info-panel_title': 'Informations générales',
  'account-company-info-panel_title': "Données de l'entreprise",
  // Profile
  'account-info-panel_profile_name': 'Nom',
  'account-info-panel_profile_lastname': 'Nom de famille',
  'account-info-panel_profile_email': 'Email',
  'account-info-panel_profile_phone-number': 'Numéro de téléphone',
  'account-info-panel_profile_department': 'Département',
  'account-info-panel_profile_security-data': 'Données de sécurité',
  'account-info-panel_profile_change-password': 'Changer le mot de passe',
  'account-info-panel_profile_pwd_password-label': 'Nouveau mot de passe',
  'account-info-panel_profile_pwd_repeat-password-label': 'Répétez le nouveau mot de passe',
  'account-info-panel_profile_pwd_change-button': 'Changer le mot de passe',
  'account-info-panel_profile_pwd_validation': 'Le mot de passe doit comporter au minimum 8 caractères et au maximum 16, 1 numéro, 1 lettre majuscule et une minuscule.',
  'account-info-panel_profile_pwd_validation-match': 'Les mots de passe ne correspondent pas',
  'account-info-panel_profile_pwd_change-success': 'Mot de passe changé avec succès.',
  'account-info-panel_profile_pwd_empty-inputs': 'Remplissez les champs vides.',
  // Profile form
  'account-profile_form-input_name': 'Entrez votre nom',
  'account-profile_form-input_name-validation': 'Veuillez entrer votre nom',
  'account-profile_form-input_lastname': 'Entrez votre nom de famille',
  'account-profile_form-input_lastname-validation': 'Veuillez entrer votre nom de famille',
  'account-profile_form-input_email': 'Entrez votre adresse e-mail',
  'account-profile_form-input_email-validation-required': 'Veuillez entrer votre adresse e-mail',
  'account-profile_form-input_email-validation': "L'adresse e-mail n'est pas valide",
  'account-profile_form-input_department': 'Entrez le département',
  'account-profile_form-input_department-validation': 'Veuillez entrer le département',
  'account-profile_form-input_phone-number': '',
  'account-profile_form-input_phone-number-validation': 'Veuillez entrer le numéro de téléphone',
  // Company
  'account-info-panel_company_title': "Données de l'entreprise",
  'account-info-panel_company_cif': "Numéro de NIF (Numéro d'Identification Fiscale)",
  'account-info-panel_company_trade-name': 'Nom commercial',
  'account-info-panel_company_business-name': 'Raison sociale',
  'account-info-panel_company_address': 'Adresse',
  'account-info-panel_company_postal-code': 'Code postal',
  'account-info-panel_company_population': 'VILLE',
  'account-info-panel_company_country': 'Pays',
  'account-info-panel_company_email': 'Email',
  'account-info-panel_company_phone-number': 'Numéro de téléphone',
  'account-info-panel_company_contact_name_fr': 'Contact Principal',
  'account-info-panel_company_metas-connected_title_fr': 'Objectifs Connectés',
  'account-info-panel_company_active-seasons_title_fr': 'Saisons Actives',
  // Company form
  'account-company_form-input_trade-name': 'Entrez le nom commercial',
  'account-company_form-input_trade-name-validation': 'Veuillez entrer le nom commercial',
  'account-company_form-input_business-name': "Entrez le nom de l'entreprise",
  'account-company_form-input_business-name-validation': "Veuillez entrer le nom de l'entreprise",
  'account-company_form-input_country': 'Entrez le pays',
  'account-company_form-input_country-validation': 'Veuillez entrer le pays',
  'account-company_form-input_population': 'Entrez la ville',
  'account-company_form-input_population-validation': 'Veuillez entrer la ville',
  'account-company_form-input_address': "Entrez l'adresse",
  'account-company_form-input_address-validation': 'Veuillez entrer votre adresse',
  'account-company_form-input_postal-code': 'Entrez le code postal',
  'account-company_form-input_postal-code-validation': 'Veuillez entrer le code postal',
  'account-company_form-input_cif': "Entrez le NIF (Numéro d'Identification Fiscale)",
  'account-company_form-input_cif-validation': "Veuillez entrer le NIF (Numéro d'Identification Fiscale)",
  'account-company_form-input_phone-number': 'Numéro de téléphone',
  'account-company_form-input_phone-number-validation': 'Veuillez entrer le numéro de téléphone',
  'account-company_form-input_email': "Entrez l'e-mail de l'entreprise",
  'account-company_form-input_contact_name_fr': "Entrez le contact principal de l'entreprise",
  'account-company_form-input_contact_name-validation-required_fr': "Veuillez entrer le contact principal de l'entreprise",
  'account-company_form-input_email-validation-required': 'Veuillez entrer votre adresse e-mail',
  'account-company_form-input_email-validation': "L'adresse e-mail n'est pas valide",
  'account-company_form-input_instagram': "Entrez l'URL Instagram",
  'account-company_form-input_youtube': "Entrez l'URL Youtube",
  'account-company_form-input_linkedin': "Entrez l'URL Linkedin",
  'account-company_form-input_facebook': "Entrez l'URL Facebook",
  'account-company_social-media-title': 'Réseaux Sociaux',
  'account-company_form-input_social-media-label': 'Nom du Réseau Social',
  'account-company_form-input_social-media-label-placeholder': 'Nom du Réseau Social',
  'account-company_form-input_social-media-label_validation': 'Veuillez entrer le nom du réseau social',
  'account-company_form-input_social-media-value': 'URL du Réseau Social',
  'account-company_form-input_social-media-value-placeholder': 'URL du Réseau Social',
  'account-company_form-input_social-media-value_validation': "Veuillez entrer l'URL du réseau social",
  'account-company_form-input_social-media-add-button': 'Ajouter un Réseau Social',
  'account-company_form-input_social-media-accept-button_title': 'Mettre à jour le Réseau Social',
  'account-company_form-input_social-media-reject-button_title': 'Annuler les modifications',
  'account-company_form-input_social-media-delete-button_title': 'Supprimer le Réseau Social',
  'account-company_form-input_social-media-delete-button_popconfirm_title': 'Supprimer le Réseau Social',
  'account-company_form-input_social-media-delete-button_popconfirm_description': 'Êtes-vous sûr de vouloir supprimer ce réseau social ?',
  'account-company_form-input_social-media-delete-button_popconfirm_ok': 'Supprimer',
  'account-company_form-input_social-media-delete-button_popconfirm_cancel': 'Annuler',
  // Main Contacts
  'main-contacts_title': 'Contacts Principaux',
  'main-contacts_add-contact': '+ Ajouter',
  'main-contacts_table_name': 'Nom',
  'main-contacts_table_lastname': 'Nom de famille',
  'main-contacts_table_email': 'E-mail',
  'main-contacts_table_phone-number': 'Numéro de téléphone',
  'main-contacts_table_department': 'Département',
  'main-contacts_table_pop-confirm_title': 'Supprimer le contact',
  'main-contacts_table_pop-confirm_description': 'Êtes-vous sûr de vouloir supprimer ce contact ?',
  'main-contacts_table_pop-confirm_btn-accept': 'Supprimer',
  'main-contacts_table_pop-confirm_btn-cancel': 'Annuler',
  // Main Contacts Form
  'main-contacts_form-label_name': 'Nom',
  'main-contacts_form-label_lastname': 'Nom de famille',
  'main-contacts_form-label_email': 'E-mail',
  'main-contacts_form-label_phone-number': 'Numéro de téléphone',
  'main-contacts_form-label_department': 'Département',
  'main-contacts_form-input_name': 'Entrez le nom',
  'main-contacts_form-input_lastname': 'Entrez le nom de famille',
  'main-contacts_form-input_email': "Entrez l'e-mail",
  'main-contacts_form-input_department': 'Entrez le département',
  'main-contacts_form_sector_label': 'Secteur',
  'main-contacts_form-input_sector': 'Entrer le secteur',
  'main-contacts_form-input_sector_validation': 'Entrer le secteur',
  'main-contacts_form-input_phone-number': 'Entrez le numéro de téléphone',
  'main-contacts_form-input-validation_name': 'Veuillez entrer le nom',
  'main-contacts_form-input-validation_lastname': 'Veuillez entrer le nom de famille',
  'main-contacts_form-input-validation_email': "L'e-mail n'est pas valide",
  'main-contacts_form-input-validation-required_email': "Veuillez entrer l'e-mail",
  'main-contacts_form-input-validation_department': 'Veuillez entrer le département',
  // Comercial agents
  'commercial-agents_add-contact': '+ Ajouter un agent',
  'commercial-agents_table_agent-name': 'Agent commercial',
  'commercial-agents_table_buy-group': 'Groupe d’achat',
  'commercial-agents_table_clients': 'Clients',
  'commercial-agents_table_clients-placeholder': 'Sélectionnez les clients',
  'commercial-agents_table_telephone': 'Téléphone',
  'commercial-agents_table_pop-confirm_title': 'Supprimer l’agent commercial',
  'commercial-agents_table_pop-confirm_description': 'Êtes-vous sûr de vouloir supprimer cet agent commercial ?',
  'commercial-agents_table_pop-confirm_btn-accept': 'Supprimer',
  'commercial-agents_table_pop-confirm_btn-cancel': 'Annuler',
  'commercial-agents_drawer_title': 'Informations commerciales',
  // Comercial agents form
  'commercial-agents_form-fiscal-google-form-title': 'Adresse fiscale',
  'commercial-agents_form-commercial-google-form-title': 'Adresse commerciale',
  'commercial-agents_form-label_name': 'Prénom',
  'commercial-agents_form-label_lastname': 'Nom de famille',
  'commercial-agents_form-label_trade-name': 'Entreprise',
  'commercial-agents_form-label_cif': 'CIF | NIF | DNI',
  'commercial-agents_form-label_phone-number': 'Téléphone',
  'commercial-agents_form-input_name': 'Entrez le prénom',
  'commercial-agents_form-label_email': 'Email',
  'commercial-agents_form-label_sector': 'Secteur',
  'commercial-agents_form-input_email': 'Entrez l’email',
  'commercial-agents_form-input_sector': 'Entrez le secteur',
  'commercial-agents_form-input_yes': 'Oui',
  'commercial-agents_form-input_no': 'Non',
  'commercial-agents_form-input_lastname': 'Entrez le nom de famille',
  'commercial-agents_form-input_trade-name': 'Entrez le nom de l’entreprise',
  'commercial-agents_form-input_cif': 'Entrez le CIF, NIF ou DNI',
  'commercial-agents_form-input_phone-number': 'Entrez le téléphone',
  'commercial-agents_form-input_web': 'Entrez le site web',
  'commercial-agents_form-input-validation_name': 'Veuillez entrer le prénom',
  'commercial-agents_form-input-validation_email': 'Veuillez entrer l’email',
  'commercial-agents_form-input-validation_sector': 'Veuillez entrer le secteur',
  'commercial-agents_form-input-validation_buy-group': 'Veuillez entrer le groupe d’achat',
  'commercial-agents_form-input-validation_lastname': 'Veuillez entrer le nom de famille',
  'commercial-agents_form-input-validation_trade-name': 'Veuillez entrer le nom de l’entreprise',
  'commercial-agents_form-input-validation_cif': 'Veuillez entrer le CIF, NIF ou DNI',
  'commercial-agents_form-input-validation_phone-number': 'Veuillez entrer le téléphone',
  // Shared
  'notification-form-item_label': 'Paramètres de notification',
  // Drawers
  'account-profile_drawer_title': 'Information Générale',
  'account-company_drawer_title': 'Données de l’Entreprise',
  'main-contacts_drawer_title': 'Contacts Principaux',
  'main-contacts_drawer_create-title': 'Créer un contact',
  'main-contacts_drawer_update-title': 'Mettre à jour le contact',
  /////////////////////////////

  // MULTIMEDIA ///////////////
  'multimedia_nav-videos': 'Vidéos',
  'multimedia_nav-images': 'Images',
  'multimedia_sort-btn': 'Trier par',
  'multimedia_filter-btn': 'Filtres',
  'multimedia_apply-filters-btn': 'Appliquer les filtres',
  'multimedia_search-input-placeholder': 'Rechercher par marque, genre, saison, pays, date',
  'multimedia_search-results': 'Résultats',
  'multimedia_download': 'Télécharger',
  'multimedia_download_started': 'Le téléchargement a commencé',
  'multimedia_open': 'Ouvrir',
  'multimedia_link-copied': 'Lien copié dans le presse-papiers',
  'multimedia_link-copy-button': 'Copier le lien',
  'multimedia_delete-popconfirm-title': 'Supprimer le fichier multimédia',
  'multimedia_delete-popconfirm-description': 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
  // Sort by
  'multimedia_sort-last-favorites': 'Favoris',
  'multimedia_sort-last-aggregates': 'Derniers ajoutés',
  'multimedia_sort-best-seller': 'Meilleures ventes',
  'multimedia_sort-less-sold': 'Moins vendu',
  'multimedia_sort-best-pvp_great-minor': 'Prix : élevé à bas',
  'multimedia_sort-best-pvp_minor-great': 'Prix : bas à élevé',
  'multimedia_sort-best-pvi_great-minor': 'PVI : élevé à bas',
  'multimedia_sort-best-pvi_minor-great': 'PVI : bas à élevé',
  'multimedia_sort-by-color': 'Par couleur de A à Z',
  'multimedia_sort-by-reference': 'Par référence de A à Z',
  // Images
  'multimedia_images_popover-edit': 'Modifier',
  'multimedia_images_popover-remove': 'Supprimer',
  'multimedia_images_popover-yes': 'Oui',
  'multimedia_images_popover-no': 'Non',
  // Filter
  'multimedia_filter-remove-filters': 'Supprimer les filtres',
  'multimedia_filter-season': 'Saison',
  'multimedia_filter-division': 'Division',
  'multimedia_filter-genders': 'Genre',
  'multimedia_filter-visualization': 'Visualisation',
  'multimedia_filter-image-rights': "Droits d'image",
  'multimedia_filter-country': 'Pays',
  'multimedia_filter-tags': 'Étiquettes',
  'multimedia_filter-favorites': 'Favoris',
  'multimedia_filter-start': 'Émis à partir de',
  'multimedia_filter-end': "Émis jusqu'à",
  //Dragger
  'multimedia_upload-images-manually_dragger_msg-error': 'Fichiers pris en charge',
  'multimedia_upload-images-manually_dragger_msg_image-size-limit_error': 'La taille de l’image doit être inférieure à 3 Mo',
  'multimedia_upload-images-manually_dragger_msg_video-size-limit_error': 'La taille de la vidéo doit être inférieure à 100 Mo',
  'multimedia_upload-images-manually_dragger_text-1': 'Cliquez ou faites glisser une image',
  // Upload image manually
  'multimedia_upload-images-manually_form-item_selection': 'Sélectionner',
  'multimedia_upload-images-manually_form-item_title': 'Titre',
  'multimedia_upload-images-manually_form-item_title-required': "S'il vous plaît, saisissez le titre de l'image",
  'multimedia_upload-images-manually_form-item_usage-required': 'Veuillez entrer le type d’utilisation',
  'multimedia_upload-images-manually_form-item_name': 'Dénomination Technique',
  'multimedia_upload-images-manually_form-item_name-required': "S'il vous plaît, saisissez le nom de l'image",
  'multimedia_upload-images-manually_form-item_description': 'Description',
  'multimedia_upload-images-manually_form-item_description-required': "S'il vous plaît, saisissez la descriptio",
  'multimedia_upload-images-manually_form-item_divisions': 'Division',
  'multimedia_upload-images-manually_form-item_season': 'Saison',
  'multimedia_upload-images-manually_form-item_language': 'Langue',
  'multimedia_upload-images-manually_form-item_genders': 'Genre',
  'multimedia_upload-images-manually_form-item_products': 'Produits',
  'multimedia_upload-images-manually_form-item_catalog_id': 'Identifiant du catalogue',
  'multimedia_upload-images-manually_form-item_catalog_id_text-1': 'Champ associé à Chronos pour définir son circuit publicitaire',
  'multimedia_upload-images-manually_form-item_catalog_id_text-2': 'Contactez Hub4Retail pour activer Chronos',
  'multimedia_upload-images-manually_form-item_usage': 'Utilisation du contenu',
  'multimedia_upload-images-manually_form-item_visualization': 'Visualisation',
  'multimedia_upload-images-manually_form-item_tags': 'Étiquettes',
  'multimedia_upload-images-manually_form-item_tags_text-1': 'Créez vos propres étiquettes" en francés',
  'multimedia_upload-images-manually_form-item_start': 'Reproductible depuis',
  'multimedia_upload-images-manually_form-item_end': "Reproductible jusqu'à",
  'multimedia_upload-images-manually_form-item_copyright': "Ce vidéo a-t-elle les droits d'image ?",
  'multimedia_upload-images-manually_form-item_enable_download': 'Permettez-vous le téléchargement?',
  'multimedia_upload-images-manually_form-item_countries': 'Pays',
  'multimedia_upload-images-manually_form-item_add': 'Ajouter',
  'multimedia_upload-images-manually_form-item_next': 'Suivant',
  'multimedia_upload-images-manually_form-item_yes': 'Oui',
  'multimedia_upload-images-manually_form-item_no': 'Non',
  // Modal manually
  'multimedia_upload-images-manually_modal_title': "Mettre à jour l'image",
  'multimedia_upload-images-manually_modal_step-1': 'Sélectionne une image',
  'multimedia_upload-images-manually_modal_step-2': 'Complétez les données',
  'multimedia_upload-images-manually_modal_step-2-msg': "Titre de l'image",
  'multimedia_upload-images-manually_modal_step-3-msg': 'Multimédia téléchargé avec succès',
  // Upload images CSV
  'multimedia_upload-images_button': 'Télécharger des images',
  'multimedia_upload-images_step-1': 'Sélectionner des images',
  'multimedia_upload-images_step-1_dragger_text-1': "Cliquez ou déposez les fichiers d'image",
  'multimedia_upload-images_step-1_dragger_text-2': 'Prenez note des éléments suivants...',
  'multimedia_upload-images_step-1_dragger_text-3': 'Enregistrez les images avec le nom',
  'multimedia_upload-images_step-1_dragger_text-4': 'référence_couleur_image#',
  'multimedia_upload-images_step-2': 'Télécharger le fichier CSV',
  'multimedia_upload-images_step-2_dragger_text-1': 'Cliquez ou déposez le fichier CSV',
  'multimedia_upload-images_step-3': 'Téléchargement terminé !',
  'multimedia_upload-images_step-3-text': "fichiers d'image téléchargés",
  'multimedia_upload-images_modal_title': 'Télécharger des images',
  'multimedia_upload-images_modal_btn-back': 'Retour',
  'multimedia_upload-images_modal_btn-next': 'Suivant',
  'multimedia_upload-images_modal_btn-close': 'Fermer',
  //Upload
  'multimedia_upload_step-2': 'Complétez les données',
  // Upload videos
  'multimedia_upload-videos_button': 'Télécharger des vidéo',
  'multimedia_upload-videos_step-1_dragger_text-1': 'Cliquez ou glissez et déposez des fichiers vidéo',
  'multimedia_upload-videos_step-1': 'Sélectionner une vidéo',
  'multimedia_upload-videos_modal_title': 'Télécharger une vidéo',
  // Upload banners
  'multimedia_upload-banners_button': 'Télécharger des bannières',
  'multimedia_upload-banners_modal_title': 'Télécharger une bannière',
  'multimedia_upload-banner_step-1': 'Sélectionner une bannière',
  'multimedia_upload-banners_step-1_dragger_text-1': 'Cliquez ou glissez et déposez une bannière',
  ////////////////////////////

  // BRAND USERS /////////////////
  'brand-user_title': 'Utilisateurs',
  'brand-user_description': 'Contrôlez comment les membres de votre équipe interagissent avec Hub4Retail.',
  'brand-user_create-user': 'Créer un utilisateur',
  'brand-user_modal_title-create': 'Ajouter un utilisateur',
  'brand-user_modal_title-edit': 'Éditer un utilisateur',
  'brand-user_modal_input_name': 'Prénom',
  'brand-user_modal_input_lastname': 'Nom',
  'brand-user_modal_input_email': 'Email',
  'brand-user_modal_input_password': 'Mot de passe',
  'brand-user_modal_input_btn-save': 'Enregistrer',
  'brand-user_modal_input_btn-cancel': 'Annuler',
  'brand-user_table_name': 'Prénom',
  'brand-user_table_email': 'Email',
  'brand-user_table_role': 'Rôle',
  'brand-user_table_last-session': 'Dernière session',
  'brand-user_table_last-session-never': 'Jamais',
  'brand-user_delete-popconfirm_title': 'Supprimer l’utilisateur',
  'brand-user_delete-popconfirm_description': 'Êtes-vous sûr de vouloir supprimer cet utilisateur?',
  'brand-user_delete-popconfirm_confirm': 'Oui',
  'brand-user_delete-popconfirm_cancel': 'Non',
  'brand-user_delete-popconfirm_icon-tooltip': 'Supprimer la connexion',
  ////////////////////////////////

  // CATALOG //////////////////
  'catalog_add-product': 'Ajouter un produit',
  'catalog_ProductList_results': 'Résultats',
  'catalog_no-more-results': 'Aucun résultat trouvé...',
  'catalog_tags_delete-all': 'Tout supprimer',
  'catalog_loading-filters': 'Chargement des filtres',
  // Sort by
  'catalog_search-input-placeholder': 'Rechercher par référence',
  // Sor by images
  'catalog_sort-by-images_with-images': 'Avec images',
  'catalog_sort-by-images_without-images': 'Sans images',
  'catalog_sort-by-images_all': 'Tous les produits',
  'catalog_sort-by-images_download-csv-products-without-images-tooltip': 'Télécharger le CSV des produits sans images',
  // Add catalog
  'catalog_add-catalog-csv-input-title': 'Télécharger CSV des produits',
  'catalog_add-catalog-csv-s1-text-1': 'Option',
  'catalog_add-catalog-csv-s1-text-2': 'Vous pouvez télécharger notre',
  'catalog_add-catalog-csv-s1-text-3': 'modèle excel',
  'catalog_add-catalog-csv-s1-text-4': 'ou',
  'catalog_add-catalog-csv-s1-text-5': 'Téléchargez votre propre modèle',
  'catalog_add-catalog-csv-s2-text-1': 'Télécharger CSV',
  'catalog_add-catalog-csv-s2-text-2': 'Télécharger des images',
  'catalog_add-catalog-csv-s2-text-3': 'Déterminer les dates de début et de fin des saisons',
  'catalog_add-catalog-csv_dowload-template-success': 'Modèle téléchargé avec succès',
  // Correlation-Generic
  'catalog-correlation_select-all': 'Toutes les références',
  'catalog-correlation_select-no-associated': 'Références uniques par générique H4R',
  'catalog-correlation_select-no-associated-at-all': 'Références non attribuées',
  'catalog-correlation_select-all_tooltip': 'Voir toutes les références disponibles',
  'catalog-correlation_select-no-associated_tooltip': "Voir les références qui ne se répètent pas dans plus d'un générique H4R",
  'catalog-correlation_select-no-associated-at-all_tooltip': 'Voir les références qui ne sont attribuées à aucun générique H4R',
  'catalog-correlation_empty-values': 'Aucune valeur sélectionnée à attribuer',
  'catalog-correlation_not-associated': 'Non attribué',
  'catalog-correlation_season-label': 'Saison',
  'catalog-correlation_gender-label': 'Genre',
  'catalog-correlation_color-label': 'Couleur',
  'catalog-correlation_color-code-label': 'Code couleur',
  'catalog-correlation_segmentation-label': 'Segmentation',
  'catalog-correlation_division-label': 'Division',
  'catalog-correlation_family-label': 'Famille',
  'catalog-correlation_table_column_h4r': 'Générique H4R',
  'catalog-correlation_unused-references': 'Références non assignées',
  'catalog-correlation_table_accept-btn': 'Enregistrer',
  'catalog-correlation_table_reject-btn': 'Annuler',
  'catalog-correlation_table_required-field': 'Champ requis',
  'catalog-correlation_table_add-field': 'Ajouter',
  'catalog-correlation_pending-correlations': 'non assignée',
  'catalog-correlation_pendings-correlations': 'non assignées',
  // Upload product images
  'catalog_handle-images_pattern_title': "Modèle d'image",
  'catalog_handle-images_pattern_description': "Sélectionnez le modèle de nom d'image :",
  'catalog_handle-images_pattern_separator': 'Séparateur :',
  'catalog_handle-images_pattern_label': 'Modèle :',
  'catalog_handle-images_pattern_save': 'Enregistrer le modèle',
  'catalog_handle-images_pattern_create-message-success': 'Modèle enregistré avec succès',
  'catalog_handle-images_pattern_create-message-error': "Erreur lors de l'enregistrement du modèle",
  'catalog_handle-images_upload_title': 'Télécharger des images',
  'catalog_handle-images_upload_upload-image-success': 'Image enregistrée',
  'catalog_handle-images_upload_upload-images-success': 'Images enregistrées',
  'catalog_handle-images_upload_upload-image-without-pattern-success': 'Image sans modèle enregistrée',
  'catalog_handle-images_upload_upload-images-without-pattern-success': 'Images sans modèle enregistrées',
  'catalog_handle-images_upload_upload-images-success-correctly': 'correctement',
  'catalog_handle-images_upload_upload-image-error': 'Erreur lors du téléchargement des images',
  'catalog_handle-images_upload_upload-image-btn': 'Télécharger des images',
  'catalog_handle-images_upload_selected-images': 'Images sélectionnées :',
  'catalog_handle-images_upload_previously-uploaded-images': 'Images déjà téléchargées :',
  'catalog_handle-images_upload_uploaded-images': 'Images téléchargées :',
  'catalog_handle-images_upload_images-without-pattern': 'Images sans modèle :',
  'catalog_handle-images_upload_save-images-confirm': 'Voulez-vous enregistrer les images sans modèle ?',
  'catalog_handle-images_not-matched-images_title': 'Images ne correspondant à aucun produit',
  'catalog_handle-images_not-matched-images_save-success': 'Images assignées avec succès',
  'catalog_handle-images_not-matched-images_save-error': "Erreur lors de l'assignation des images",
  'catalog_handle-images_not-matched-images_search-placeholder': 'Rechercher des images par référence',
  'catalog_handle-images_not-matched-images_search-clear-btn': 'Effacer la recherche',
  'catalog_handle-images_not-matched-images_assign-product-btn': 'Assigner au produit',
  'catalog_handle-images_not-matched-images_cancel-product-selection': 'Annuler la sélection',
  // Catalog download
  'catalog_download_alert_brand-required': 'Veuillez sélectionner une marque',
  'catalog_download_alert_get-filters-error': 'Erreur lors de la récupération des filtres',
  'catalog_download_alert_dowloading-compressed-files': 'Téléchargement des fichiers compressés...',
  'catalog_download_progress-images': 'Images',
  'catalog_download_success-msg': 'Images téléchargées avec succès',
  'catalog_download_success-msg-imgs-and-csv': 'CSV et images téléchargés avec succès',
  'catalog_download_csv-msg-without-images': 'CSV téléchargé avec succès',
  'catalog_download_csv-msg-pending-images': 'CSV téléchargé avec succès, mais les images sont en attente',
  'catalog_download_csv-msg-pending-images-navigate': 'CSV téléchargé avec succès, mais les images sont en attente. Vous pouvez continuer à naviguer pendant le téléchargement',
  'catalog_download_apply-changes-btn': 'Appliquer les modifications',
  'catalog_download_cancel-filter-btn': 'Annuler',
  'catalog_download_cancel-values-selection-btn': 'Effacer la sélection',
  'catalog_download_cancel-values-download-btn': 'Annuler le téléchargement',
  'catalog_download_clear-filters-btn': 'Effacer les filtres',
  'catalog_download_result': 'résultat',
  'catalog_download_results': 'résultats',
  'catalog_download_select-column': 'Sélectionner la colonne',
  'catalog_download_input-seasons': 'Entrez les saisons',
  'catalog_download_input-value': 'Entrez la valeur',
  'catalog_download_update': 'Mettre à jour',
  'catalog_download_columns_search-on': 'Rechercher dans',
  'catalog_download_columns_operator_contains': 'Contient',
  'catalog_download_columns_operator_ends-with': 'Se termine par',
  'catalog_download_columns_operator_starts-with': 'Commence par',
  'catalog_download_columns_operator_equals': 'Égal',
  'catalog_download_columns_operator_not-equals': 'Différent',
  'catalog_download_columns_operator_in': 'Dans',
  'catalog_download_columns_operator_not-in': 'Pas dans',
  'catalog_download_columns_operator_greater-than': 'Supérieur à',
  'catalog_download_columns_operator_less-than': 'Inférieur à',
  'catalog_download_columns_operator_is-null': 'Est vide',
  'catalog_download_columns_operator_is-not-null': 'N\'est pas vide',
  'catalog_download_columns_all-images': 'Tous les produits',
  'catalog_download_columns_with-images': 'Avec images',
  'catalog_download_columns_without-images': 'Sans images',
  'catalog_download_columns_favorites': 'Favoris',
  'catalog_download_columns_not-downloaded': 'Non téléchargé',
  'catalog_download_columns_column-search_search': 'Rechercher',
  'catalog_download_columns_column-search_reset': 'Réinitialiser',
  'catalog_download_columns_column-search_close': 'Fermer',
  'catalog_download_list_select-all': 'Tout sélectionner',
  'catalog_download_list_clear-all': 'Effacer la sélection',
  'catalog_download_list_download-btn': 'Télécharger',
  'catalog_download_list_download-images-btn': 'Télécharger les images',
  'catalog_download_list_item': 'élément',
  'catalog_download_list_items': 'éléments',
  'catalog_download_list_select-order_popover-title': 'Sélectionnez et triez',
  ///////////////////////////

  // TABLES ///////////////////////////////////////
  'table_columns_brand': 'Marque',
  'table_columns_reference': 'Référence',
  'table_columns_ean': 'EAN Marque',
  'table_columns_size': 'Taille',
  'table_columns_name': 'Nom',
  'table_columns_color': 'Description de la couleur',
  'table_columns_color_code': 'Code couleur',
  'table_columns_pvi': 'PVI',
  'table_columns_pvpr': 'PVPR',
  'table_columns_division': 'Division',
  'table_columns_gender': 'Genre',
  'table_columns_season': 'Saison',
  'table_columns_segmentation': 'Segmentation',
  'table_columns_family': 'Famille',
  'table_columns_material': 'Composition',
  'table_columns_images': 'Images',
  'table_columns_product_description': 'Description du produit',
  'table_columns_client_ean': 'EAN Multimarque',
  'table_columns_count': 'Répétitions',
  'table_columns_size_uk': 'Taille UK',
  'table_columns_size_us': 'Taille US',
  'table_columns_brand_name': 'Nom de la marque',
  /////////////////////////////////////////////////

  // PRODUCT /////////////////
  'product_infoBox_codeEAN': 'Code EAN',
  'product_collection_title': 'Toute la collection',
  'product_infoProduct_other_colors': 'Autres couleurs',
  'product_infoProduct_currency': '€',
  'product_infoProduct_sizes': 'Tailles et prix',
  'product_infoProduct_EAN_size': 'Tailles',
  'product_infoProduct_EAN_code': 'Codes EAN',
  'product_collapse_title_key1': 'Tailles',
  'product_collapse_title_key2': 'INFORMATIONS GÉNÉRALES',
  'product_collapse_title_key3': 'COMPOSITION',
  'product_card-color': 'couleur',
  'product_mobile_product-details_sizes': 'Tailles et prix',
  'product_mobile_product-details_size': 'Taille',
  'product_mobile_product-details_info': 'Information Générale',
  'product_mobile_product-details_ean-codes': 'Codes EAN',
  'product_mobile_product-details_ean-code': 'Code EAN',
  'product_mobile_product-details_composition': 'Composition',
  'product_related-videos_title': 'Catalogue Multimédia',
  'product_related-videos_subtitle': 'Vidéos Associées',
  'product_related-products_title': 'Cela pourrait aussi vous intéresser...',
  'product_card_sold-units': 'Unités vendues:',
  'product_card_ranking': 'Classement:',
  // Edit product
  'product_edit-product_button': 'Modifier le produit',
  'product_edit-product_modal_title': 'Modifier',
  'product_edit-product_modal_season': 'Saison',
  'product_edit-product_modal_season_required': 'Veuillez entrer la saison',
  'product_edit-product_modal_product-description': 'Description du produit',
  'product_edit-product_modal_product-description_required': 'Veuillez entrer la description',
  'product_edit-product_modal_color-name': 'Nom de la couleur',
  'product_edit-product_modal_color-name_required': 'Veuillez entrer le nom de la couleur',
  'product_edit-product_modal_color-code': 'Code de la couleur',
  'product_edit-product_modal_color-code_required': 'Veuillez entrer le code de la couleur',
  'product_edit-product_modal_gender': 'Genre',
  'product_edit-product_modal_gender_required': 'Veuillez entrer le genre',
  'product_edit-product_modal_family': 'Famille',
  'product_edit-product_modal_family_required': 'Veuillez entrer la famille',
  'product_edit-product_modal_division': 'Division',
  'product_edit-product_modal_division_required': 'Veuillez entrer la division',
  'product_edit-product_modal_segmentation': 'Segmentation',
  'product_edit-product_modal_segmentation_required': 'Veuillez entrer la segmentation',
  'product_edit-product_modal_material': 'Composition',
  'product_edit-product_modal_material_required': 'Veuillez entrer la composition',
  'product_edit-product_modal_cancel-button': 'Annuler',
  'product_edit-product_modal_save-button': 'Enregistrer',
  ///////////////////////////

  // THANKS PAGE ////////////
  'ThanksForRegister__register': 'ENREGISTREMENT DES MARQUES',
  'ThanksForRegister__title': 'Merci de votre intérêt pour Hub4Retail!',
  'ThanksForRegister__subtitle': 'Votre demande est en cours de traitement et nous vous contacterons sous peu.',
  'ThanksForRegister__button': 'Aller sur le site web',
  ///////////////////////////

  // REGISTER BRAND PAGE ////////////
  'RegisterBrand__title1': 'Prêt à commencer à',
  'RegisterBrand__title2': 'amener votre entreprise au',
  'RegisterBrand__title3': 'niveau suivant?',
  'RegisterBrand__subtitle': 'Plateforme conçue pour :',
  'RegisterBrand__ex1': 'Améliorer les outils de collaboration et de partage.',
  'RegisterBrand__ex2': 'Assurer la sécurité des données à tout moment.',
  'RegisterBrand__ex3': 'Augmenter les marges de profit.',
  'RegisterBrand__button': 'Retour',
  'RegisterBrand__register': 'Enregistrement',
  'registerBrand__form__name': 'Prénom',
  'registerBrand__form__lastName': 'Nom',
  'registerBrand__form__business': 'Raison Sociale',
  'registerBrand__form__company': 'Nom Commercial',
  'registerBrand__form__phone': 'Web',
  'registerBrand__form__email': 'Téléphone',
  'registerBrand__form__web': 'Email Corporatif',
  'registerBrand__form__description': 'Voulez-vous nous en dire plus?',
  'registerBrand__form__selector': 'Secteur',
  'registerBrand__form__say-more': 'Voulez-vous nous en dire plus?',
  'registerBrand__form__selector__optionDefault': '',
  'registerBrand__form__selector__option1': 'Chaussures',
  'registerBrand__form__selector__option2': 'Accessoires',
  'registerBrand__form__selector__option3': 'Maison-Jardin',
  'registerBrand__form__selector__option4': 'Beauté',
  'registerBrand__form__selector__option5': 'Électronique',
  'registerBrand__form__selector__option6': 'Sport',
  'registerBrand__form__selector__option7': 'Automobile',
  'registerBrand__form__selector__option8': 'Alimentaire',
  'registerBrand__form__selector__option9': 'Autre',
  ///////////////////////////

  // CLIENTS ///////////////
  'clients_by-client-btn': 'Par client',
  'clients_by-points-sale-btn': 'Par point de vente',
  'clients_add-client-link': '+ Ajouter un client',
  'clients_add-search-input': 'Rechercher...',
  'clients_filters-btn': 'Filtres',
  // Tables
  'clients_clients-table_businessName': 'Raison sociale',
  'clients_clients-table_tradeName': 'Nom commercial',
  'clients_clients-table_clientCode': 'Code client',
  'clients_clients-table_tarif-code': 'Code tarifaire',
  'clients_clients-table_city': 'Ville',
  'clients_clients-table_totalPointsSale': 'Total des points de vente',
  'clients_clients-table_totalPointsSale_popover-title': 'Il y a des points de vente avec de nouvelles données',
  'clients_clients-table_totalPointsSale_popover-btn': 'Aller aux points de vente',
  'clients_clients-table_totalPointsSale_client-popover-title': 'a mis à jour les données',
  'clients_clients-table_totalPointsSale_client-popover-content': 'données ajoutées ou mises à jour',
  'clients_clients-table_totalPointsSale_client-popover-content-2': 'données ajoutées ou mises à jour',
  'clients_clients-table_totalPointsSale_client-popover-btn': 'Aller au client',
  'clients_client-table_status': 'Statut',
  'clients_client-table_action_see-profile': 'Voir le profil',
  'clients_client-table_action_remove-popconfirm_title': "Rejeter l'association",
  'clients_client-table_action_remove-popconfirm_description': 'Êtes-vous sûr de vouloir rejeter cette association ?',
  'clients_client-table_action_remove-popconfirm_on-ok': 'Accepter',
  'clients_client-table_action_remove-popconfirm_on-cancel': 'Annuler',
  'clients_client-table_action_reject-popconfirm_title_fr': "Dissocier l'Association",
  'clients_client-table_action_reject-popconfirm_description_fr': 'Êtes-vous sûr de vouloir dissocier cette association ?',
  'clients_client-table_action_reject-popconfirm_on-ok_fr': 'Accepter',
  'clients_client-table_action_reject-popconfirm_on-cancel_fr': 'Annuler',
  'clients_client-table_action_delete-popconfirm_title': 'Supprimer le point de vente',
  'clients_client-table_action_delete-popconfirm_description': 'Êtes-vous sûr de vouloir supprimer ce point de vente ?',
  'clients_client-table_action_delete-popconfirm_icon-tooltip': 'Supprimer le point de vente',
  'clients_client-table_action_dissasociate-popconfirm_on-ok': 'Dissocier',
  'client_clients-page_table_disassociate-modal_title_fr': 'Dissocier le Client',
  'client_clients-page_table_disassociate-modal_on-ok_fr': 'Dissocier',
  'client_clients-page_table_disassociate-modal_on-cancel_fr': 'Annuler',
  'client_clients-page_table_disassociate-modal_content_fr': 'Êtes-vous sûr de vouloir dissocier ce client et tous ses points de vente ?',
  'clients_sale-point-table_businessName': 'Raison sociale',
  'clients_sale-point-table_shop-name': 'Nom du magasin',
  'clients_sale-point-table_category': 'Catégorie',
  'clients_sale-point-table_tradeName': 'Nom commercial',
  'clients_sale-point-table_pointSaleCode': 'Code du point de vente',
  'clients_sale-point-table_city': 'Ville',
  'clients_sale-point-table_personae-and-tier': 'Personae et Tier',
  'clients_sale-point-table_share-data': 'Partage de données',
  'clients_sale-point-table_share-data-popover-share': 'Réception des données de vente du client.',
  'clients_sale-point-table_share-data-popover-no-share': 'Non réception des données de vente du client.',
  'clients_sale-point-table_recive-data': 'Réception de données',
  'clients_sale-point-table_recive-data_green_fr': 'Réception des données de vente du client.',
  'clients_sale-point-table_recive-data_orange_fr': 'Le client ne partage pas les données.',
  'clients_sale-point-table_recive-data_red_fr': "Aucune donnée n'est reçue de l'objectif.",
  'clients_sale-point-table_connection': 'Connexion',
  'clients_sale-point-table_connection-popover-share': 'Connecté au terminal de point de vente du client.',
  'clients_sale-point-table_connection-popover-no-share': 'Non connecté au terminal de point de vente du client.',
  'clients_sale-point-table_active': 'Actif',
  'clients_sale-point-table_inactive': 'Inactif',
  'clients_sale-point-table_connected': 'Connecté',
  'clients_sale-point-table_not-connected': 'Non connecté',
  'clients_sale-point-table_total-clients': 'Total des clients',
  'clients_sale-point-table_total-sale-points': 'Total des points de vente',
  // Association
  'clients_association-modal_title': 'Associer un client',
  'clients_association-modal_associate-label_associate_txt-1': 'Associer:',
  'clients_association-modal_associate-label_associate_txt-2': "l'association est créée et les données du point de vente propre sont conservées.",
  'clients_association-modal_associate-label_associate-update_txt-1': 'Associer et mettre à jour:',
  'clients_association-modal_associate-label_associate-update_txt-2': "l'association est créée et les données du point de vente à associer sont copiées.",
  'clients_association-modal_update-label_associate_txt-1': 'Mettre à jour:',
  'clients_association-modal_update-label_associate_txt-2': 'les données du point de vente sont copiées avec le point de vente propre.',
  'clients_association-modal_update-label_associate-update_txt-1': 'Mettre à jour et associer:',
  'clients_association-modal_update-label_associate-update_txt-2': "l'association est créée et les données du point de vente à associer sont copiées.",
  'clients_pending-association-modal_title': 'Associations en attente',
  'clients_pending-association-modal_no-more': 'Ne plus afficher',
  'clients_pending-association-modal_close': 'Fermer',
  'clients_association-modal_on-ok': 'Accepter',
  'clients_association-modal_on-finish': 'Terminer',
  'clients_association-modal_on-next': 'Suivant',
  'clients_association-modal_on-cancel': 'Annuler',
  'clients_association-modal_ps_pdv-code_fr': 'Code PDV',
  'clients_association-modal_ps_associate_fr': 'Associer',
  'clients_association-modal_ps_update_fr': 'Mettre à jour',
  'clients_association-modal_ps_empty-ps_fr': 'Pas de nouveaux points de vente',
  'clients_association-table_item_client-code': 'Code Client',
  'clients_association-table_item_cif': 'Numéro CIF',
  'clients_association-table_item_trade-name': 'Nom Commercial',
  'clients_association-table_item_business-name': 'Raison Sociale',
  'clients_association-table_item_address': 'Adresse',
  'clients_association-table_item_postal-code': 'Code Postal',
  'clients_association-table_item_city': 'Ville',
  'clients_association-table_item_province': 'Province',
  'clients_association-table_item_country': 'Pays',
  'clients_association-table_item_contact_fr': 'Contact',
  'clients_association-table_item_email': 'Courriel',
  'clients_association-table_item_phone-number': 'Téléphone',
  'clients_association-steps_step-1': 'Informations Générales',
  'clients_association-steps_step-2': 'Points de Vente',
  // Add client form
  'clients_add-client-form-label_trade-name': 'Nom commercial',
  'clients_add-client-form-label_business-name': 'Raison sociale',
  'clients_add-client-form-label_client-code': 'Code client',
  'clients_add-client-form-label_clientCode': 'Code client',
  'clients_add-client-form-label_country': 'Pays',
  'clients_add-client-form-label_population': 'Ville',
  'clients_add-client-form-label_province': 'Province',
  'clients_add-client-form-label_address': 'Adresse',
  'clients_add-client-form-label_postal-code': 'Code postal',
  'clients_add-client-form-label_cif': "Numéro de NIF (Numéro d'Identification Fiscale)",
  'clients_add-client-form-label_commercial-agents': 'Agents commerciaux',
  'clients_add-client-form-label_commercial-agents_placeholder': 'Sélectionnez des agents commerciaux',
  'clients_add-client-form-label_phone-number': 'Numéro de téléphone',
  'clients_add-client-form-label_email': 'Email',
  'clients_add-client-form-input-validation_trade-name': 'Veuillez entrer le nom commercial',
  'clients_add-client-form-input-validation_business-name': 'Veuillez entrer la raison sociale',
  'clients_add-client-form-input-validation_country': 'Veuillez entrer le pays',
  'clients_add-client-form-input-validation_population': 'Veuillez entrer la ville',
  'clients_add-client-form-input-validation_address': `Veuillez entrer l'adresse`,
  'clients_add-client-form-input-validation_postal-code': 'Veuillez entrer le code postal',
  'clients_add-client-form-input-validation_cif': "Veuillez entrer le numéro de NIF (Numéro d'Identification Fiscale)",
  'clients_add-client-form-input-validation_email-required': `Veuillez entrer l'email`,
  'clients_add-client-form-input-validation_email': 'Email invalide',
  'clients_add-client-form-input-validation_phone-number': 'Veuillez entrer le numéro de téléphone',
  // Ajouter un client
  'clients_add-client_add-manually': 'Ajouter un client manuellement',
  'clients_add-client_add-by-csv-1': 'Importer un fichier CSV',
  'clients_add-client_add-by-csv-2': 'clients',
  'clients_add-client_add-by-excel': 'Télécharger le modèle Excel',
  // Menu client
  'clients_menu-desktop_resume': 'Résumé',
  'clients_menu-desktop_main-contacts': 'Contacts',
  'clients_menu-desktop_sale-points': 'Points de vente',
  'clients_menu-desktop_brands-sold': 'Marques vendues',
  // Client resume
  'client_resume_title': 'Catalogue disponible',
  'client_resume_main-info-panel_title': 'Informations générales',
  'client_resume_main-info-panel_li-info_client-code': 'Code client :',
  'client_resume_main-info-panel_li-info_trade-name': 'Nom commercial :',
  'client_resume_main-info-panel_li-info_legal-name': 'Raison sociale:',
  'client_resume_main-info-panel_li-info_cif': 'SIREN:',
  'client_resume_main-info-panel_li-info_tarif': 'Code tarifaire :',
  'client_resume_address-info_address__title': 'Adresse postale',
  'client_resume_address-info_address': 'Adresse',
  'client_resume_address-info_postal_code': 'Code postal',
  'client_resume_address-info_city': 'Ville',
  'client_resume_address-info_province': 'Province',
  'client_resume_address-info_country': 'Pays',
  'client_resume_social-media-info_title': 'Réseaux sociaux',
  'client_resume_main-info-panel_li-info_web-page': 'Site Web:',
  'client_resume_main-info-panel_li-info_points-of-sale': 'Points de vente:',
  'client_resume_main-info-panel_li-info_email': 'E-mail :',
  'client_resume_main-info-panel_li-info_category': 'Catégorie :',
  'client_resume_main-info-panel_li-info_start-date': 'Date de début :',
  'client_resume_main-info-panel_li-info_start-season': 'Saison de début :',
  'client_resume_main-info-panel_li-info_phone-number': 'Téléphone :',
  'client_resume_main-info-panel_li-info_main-contact': 'Contact principal :',
  'client_resume_main-info-panel_li-info_contact-email': 'E-mail du contact :',
  'client_resume_main-info_item-key_name': 'Nom commercial',
  'client_resume_main-info_item-key_legal_name': 'Raison sociale',
  'client_resume_main-info_item-key_cif': 'Numéro de TVA',
  'client_resume_main-info_item-key_address': 'Adresse',
  'client_resume_main-info_item-key_postal_code': 'Code postal',
  'client_resume_main-info_item-key_city': 'Ville',
  'client_resume_main-info_item-key_country_id': 'Pays',
  'client_resume_main-info_item-key_province': 'Province',
  'client_resume_main-info_item-key_email': 'Email',
  'client_resume_main-info_item-key_contact_name': 'Contact principal',
  'client_resume_main-info_item-key_tel_prefix': 'Préfixe',
  'client_resume_main-info_item-key_tel_sufix': 'Suffixe',
  'client_resume_main-info_item-key_web': 'Site web',
  'client_resume_main-info_item-key_floor': 'Étage',
  'client_resume_main-info_item-key_door': 'Porte',
  'client_resume_main-info_upgrade_new-value': 'Nouveau',
  'client_resume_main-info_upgrade_new-actual': 'Actuel',
  'client_resume_main-info_upgrade_popover_update': 'Mettre à jour',
  'client_resume_main-info_upgrade_client-updates': 'a changé',
  'client_resume_main-info_edit-button': 'Éditer',
  'client_resume_main-info_upgrade_all-popover_title': 'Mettre à jour les nouvelles données',
  'client_resume_main-info_upgrade_popover_update-all': 'Tout mettre à jour',
  //////////////////////////

  // CLIENT ///////////////
  // Resume page
  'client_resume-page_history': 'Historique',
  'client_resume-page_accept-association': 'Associer',
  'client_resume-page_reject-association': 'Rejeter',
  'client_resume-page_accept-association_btn-title': "Accepter l'association",
  'client_resume-page_reject-association_btn-title': "Rejeter l'association",
  'client-page_history-points-of-sale_associated': 'Associé',
  'client-page_history-points-of-sale_not-associated': 'Non associé',
  'client-page_history-active-contacts_name': 'Nom',
  'client-page_history-active-contacts_email': 'Email',
  'client-page_history-active-contacts_phone-number': 'Nº de téléphone',
  'client-page_history-active-contacts_department': 'Département',
  // Client brands sold
  'client_brands-sold_title': 'Marques avec lesquelles il travaille',
  'client_brands-sold_brands_no-results': 'Aucun résultat trouvé...',
  'client_brands-sold_brands_no-brands-sold': 'Aucune marque vendue pour l\'instant...',
  // Client contacts page
  'client_contacts-page_contacts-title': 'Contacts du client',
  'client_contacts-page_agents-title': 'Agents commerciaux du client',
  // Sale points page
  'client_sale-points-page_title': 'Points de Vente',
  'client_sale-points-page_add-sale-point': '+ Ajouter',
  'client_sale-points-page_associate-sale-point': 'Point de vente associé',
  'client_sale-points-page_table_client-code': 'Code',
  'client_sale-points-page_table_address': 'Adresse',
  'client_sale-points-page_table_city': 'Ville',
  'client_sale-points-page_table_division': 'Division',
  'client_sale-points-page_table_personae': 'Personae',
  'client_sale-points-page_table_tier': 'Niveau',
  'client_sale-points-page_table_pdv': 'Photos du Point de Vente',
  'client_sale-points-page_table_name': 'Nom',
  'client_sale-points-page_table_area': 'Surface commerciale (M2)',
  'client_sale-points-page_table_category': 'Catégorie',
  'client_sale-points-page_table_brands': 'Marques',
  'client_sale-points-page_table_brands-tooltip': 'Marques en magasin',
  'client_sale-points-page_table_pos-currency': 'Devise',
  'client_sale-points-page_table_pos-last-exchange-rate': 'Taux de change',
  'client_sale-points-page_table_disassociate-modal_title_fr': 'Dissocier le Point de Vente',
  'client_sale-points-page_table_disassociate-modal_on-ok_fr': 'Dissocier',
  'client_sale-points-page_table_disassociate-modal_on-cancel_fr': 'Annuler',
  'client_sale-points-page_table_disassociate-modal_content_fr': 'Êtes-vous sûr de vouloir dissocier ce point de vente ?',
  'client_sale-points-page_table_associate-modal_title_fr': 'Lier les Points de Vente',
  'client_sale-points-page_table_associate-modal_on-ok_fr': 'Mettre à jour',
  'client_sale-points-page_table_associate-modal_on-cancel_fr': 'Annuler',
  'client_sale-points-page_table_status_associated': 'Associé',
  'client_sale-points-page_table_status_matching': 'En attente',
  'points-of-sale_drawer_exchange_label': 'Devise',
  'points-of-sale_drawer_add-edit-sale-point_exchange_input-validation': 'Veuillez entrer le type de monnaie',
  'client_sale-points-page_table_status_not-associated': 'Non Associé',
  'client_sale-points-page_upgrade_online': 'Magasin physique',
  'client_sale-points-page_upgrade_category_id': 'Catégorie',
  'client_sale-points-page_upgrade_name': 'Nom du magasin',
  'client_sale-points-page_upgrade_exchange_id': 'Type de devise',
  'client_sale-points-page_upgrade_area': 'Zone commerciale',
  'client_sale-points-page_upgrade_address': 'Adresse',
  'client_sale-points-page_upgrade_floor': 'Étage',
  'client_sale-points-page_upgrade_door': 'Porte',
  'client_sale-points-page_upgrade_city': 'Ville',
  'client_sale-points-page_upgrade_province': 'Province',
  'client_sale-points-page_upgrade_postal_code': 'Code postal',
  'client_sale-points-page_upgrade_country_id': 'Pays',
  'client_sale-points-page_upgrade_lat': 'Latitude',
  'client_sale-points-page_upgrade_lng': 'Longitude',
  'client_sale-points-page_upgrade_tel_prefix': 'Préfixe téléphonique',
  'client_sale-points-page_upgrade_tel_sufix': 'Numéro de téléphone',
  'client_sale-points-page_upgrade_web': 'Web',
  'client_sale-points-page_upgrade_popconfirm-title': 'Mettre à jour les données des points de vente',
  'client_sale-points-page_upgrade_popconfirm-description': 'Êtes-vous sûr de vouloir mettre à jour les données de tous les points de vente ?',
  'client_sale-points-page_upgrade_upgrade-btn': 'Mettre à jour les points de vente',
  'client_business-info_upgrade_all-popover_title': 'Mettre à jour les données du point de vente',
  'client_business-info_upgrade_popover_update-all': 'Tout mettre à jour',
  // Point of sale info modal
  'points-of-sale_point-of-sale-info_close-btn': 'Fermer',
  // Info
  'points-of-sale_point-of-sale-info_info_title': 'Informations',
  'points-of-sale_point-of-sale-info_info_code': 'Code',
  'points-of-sale_point-of-sale-info_info_store-type': 'Type de magasin',
  'points-of-sale_point-of-sale-info_info_store-type_online': 'En ligne',
  'points-of-sale_point-of-sale-info_info_store-type_physic': 'Physique',
  'points-of-sale_point-of-sale-info_info_category': 'Catégorie',
  'points-of-sale_point-of-sale-info_info_web': 'Page Web',
  'points-of-sale_point-of-sale-info_info_exchange-type': 'Type de devise',
  'points-of-sale_point-of-sale-info_info_start-season': 'Début de saison',
  'points-of-sale_point-of-sale-info_info_division': 'Division',
  'points-of-sale_point-of-sale-info_info_segmentation': 'Personae',
  'points-of-sale_point-of-sale-info_info_tier': 'Niveau',
  // Connection
  'points-of-sale_point-of-sale-info_connection_title': 'Connexion',
  'points-of-sale_point-of-sale-info_connection_no-associated': 'Aucune association avec le point de vente',
  'points-of-sale_point-of-sale-info_connection_meta-connection': 'Connexion avec Meta',
  'points-of-sale_point-of-sale-info_connection_meta-connection_true': 'Connecté',
  'points-of-sale_point-of-sale-info_connection_meta-connection_false': 'Non connecté',
  'points-of-sale_point-of-sale-info_connection_meta-receiving': 'Reçoit des données de Meta',
  'points-of-sale_point-of-sale-info_connection_meta-receiving_true': 'heures sans recevoir de données',
  'points-of-sale_point-of-sale-info_connection_meta-receiving_false': 'Ne reçoit pas de données',
  'points-of-sale_point-of-sale-info_connection_data-share':
    'Le client partage des données',
  'points-of-sale_point-of-sale-info_connection_data-share_true': 'Partage',
  'points-of-sale_point-of-sale-info_connection_data-share_false': 'Ne partage pas',
  // Contact
  'points-of-sale_point-of-sale-info_contact_title': 'Contact',
  'points-of-sale_point-of-sale-info_contact_contact-name': 'Personne de contact',
  'points-of-sale_point-of-sale-info_contact_phone-number': 'Téléphone de contact',
  'points-of-sale_point-of-sale-info_contact_email': 'Email',
  'points-of-sale_point-of-sale-info_contact_address': 'Adresse',
  // Brand works
  'points-of-sale_point-of-sale-info_contact_brand-works_title_0': 'marques à',
  'points-of-sale_point-of-sale-info_contact_brand-works_title_1': 'marque à',
  'points-of-sale_point-of-sale-info_contact_brand-works_empty': 'Pas encore de marques au point de vente',
  // Drawers
  // Sale points
  'client_drawer_add-edit-sale-point_title': 'Données de point de vente',
  'client_drawer_add-edit-sale-point_name': 'Nom',
  'client_drawer_add-edit-sale-point_point-of-sale-type_fr': 'Type de Point de Vente',
  'client_drawer_add-edit-sale-point_point-of-sale-type_physical_fr': 'Magasin Physique',
  'client_drawer_add-edit-sale-point_point-of-sale-type_online_fr': 'Magasin en Ligne',
  'client_drawer_add-edit-sale-point_category_fr': 'Catégorie',
  'client_drawer_add-edit-sale-point_client-code': 'Code',
  'client_drawer_add-edit-sale-point_client-area': 'Surface commerciale (M2)',
  'points-of-sale_drawer_own-point-of-sale_input': 'Magasin propre',
  'client_drawer_add-edit-sale-point_address': 'Adresse',
  'client_drawer_add-edit-sale-point_postal-code': 'Code Postal',
  'client_drawer_add-edit-sale-point_city': 'Ville',
  'client_drawer_add-edit-sale-point_country': 'Pays / Région',
  'client_drawer_add-edit-sale-point_province': 'État / Province',
  'client_drawer_add-edit-sale-point_name_input-validation': 'Veuillez entrer le nom du point de vente',
  'client_drawer_add-edit-sale-point_category_input-validation_fr': 'Veuillez saisir la catégorie du point de vente',
  'client_drawer_add-edit-sale-point_client-code_input-validation': 'Veuillez entrer le code client',
  'client_drawer_add-edit-sale-point_address_input-validation': "Veuillez entrer l'adresse",
  'client_drawer_add-edit-sale-point_postal-code_input-validation': 'Veuillez entrer le code postal',
  'client_drawer_add-edit-sale-point_city_input-validation': 'Veuillez entrer la ville',
  'client_drawer_add-edit-sale-point_country_input-validation': 'Veuillez entrer le pays / la région',
  'client_drawer_add-edit-sale-point_province_input-validation': "Veuillez entrer l'État / la Province",
  'client_drawer_add-edit-sale-point_division': 'Division',
  'client_drawer_add-edit-sale-point_personae': 'Personae',
  'client_drawer_add-edit-sale-point_tier': 'Niveau',
  'client_drawer_add-edit-sale-point_share-sale-point-title': 'Classification du Point de Vente',
  'client_drawer_add-edit-sale-point_share-sale-point-data': 'Souhaitez-vous partager des données avec ce point de vente?',
  'client_drawer_add-edit-sale-point_share-sale-point-data-true': 'Oui',
  'client_drawer_add-edit-sale-point_share-sale-point-data-false': 'Non',
  'client_drawer_add-edit-sale-point_exchange-rates_title': 'Devise et taux de change',
  'client_drawer_add-edit-sale-point_exchange-rates_start-date': 'Date de début',
  'client_drawer_add-edit-sale-point_exchange-rates_start-date_required': 'Veuillez entrer la date de début',
  'client_drawer_add-edit-sale-point_exchange-rates_end-date': 'Date de fin',
  'client_drawer_add-edit-sale-point_exchange-rates_rate': 'Taux de change',
  'client_drawer_add-edit-sale-point_exchange-rates_rate_required': 'Veuillez entrer le taux de change',
  'client_drawer_add-edit-sale-point_exchange-rates_add-new-rate-btn': 'Ajouter un taux de change',
  'client_drawer_add-edit-sale-point_exchange-rates_add-new-rate_warning': "Veuillez entrer une date de fin pour le dernier taux de change avant d'ajouter un nouveau.",
  'client_drawer_add-edit-sale-point_exchange-rates_save-modal_title': 'Enregistrer les modifications',
  'client_drawer_add-edit-sale-point_exchange-rates_save-modal_content': 'Êtes-vous sûr de vouloir enregistrer les modifications ?',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate-since': 'Taux de change depuis',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate-to': "jusqu'à",
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_button': 'Historique',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_title': 'Historique des taux de change',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_date': 'Date :',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_user': 'Utilisateur :',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_rate': 'Taux de change :',
  'client_drawer_add-edit-sale-point_exchange-rates_accept-button_title': 'Accepter les modifications',
  'client_drawer_add-edit-sale-point_exchange-rates_reject-button_title': 'Rejeter les modifications',
  'client_drawer_add-edit-sale-point_exchange-rates_pos-currency-tooltip': 'Devise du point de vente',
  'client_drawer_add-edit-sale-point_exchange-rates_company-currency-tooltip': "Devise de l'entreprise",
  // Edit client
  'client_drawer_edit-client_title': "Données de l'entreprise",
  // Assign client agents
  'client_drawer_assign-client-commercial-agents_title': 'Assigner des agents commerciaux',
  'client_drawer_assign-client-commercial-agents_create-btn': 'Créer nouveau',
  ///////////////////////////

  // META ///////////////////////////
  'meta_connections_title': 'Connexions',
  'meta_connections_new-connection': '+ Nouveau',
  'meta_connections_modal_title': 'Nouvelle connexion',
  'meta_connections_modal_title_edit': 'Modifier la connexion',
  'meta_connections_modal_form_user-name': "Nom d'utilisateur",
  'meta_connections_modal_form_user-name_required': "Veuillez entrer le nom d'utilisateur",
  'meta_connections_modal_form_password': 'Mot de passe',
  'meta_connections_modal_form_password_required': 'Veuillez entrer le mot de passe',
  'meta_connections_modal_form_period': 'Fréquence',
  'meta_table_createdAt': 'Date de création',
  'meta_table_user-name': 'Utilisateur',
  'meta_table_password': 'Mot de passe',
  'meta_table_type': 'Type',
  'meta_table_period': 'Fréquence de soumission',
  'meta_connections_configuration-btn': 'Configuration',
  'meta_connections_configuration-btn_maps': 'Cartes',
  'meta_connections_configuration-btn_fields': 'Instructions',
  'meta_connections_configuration-btn_shopify': 'Shopify',
  'meta_connections_shopify-configuration_copy': 'Copier',
  'meta_connections_shopify-configuration_query-templates': 'Modèles de requêtes Hub4Retail',
  'meta_connections_shopify-configuration_query-templates_table_title': 'Mes modèles de requêtes',
  'meta_connections_shopify-configuration_query-templates_table_tag': 'Tag',
  'meta_connections_shopify-configuration_query-templates_table_queries': 'Requêtes',
  'meta_connections_shopify-configuration_query-templates_table_popconfirn-delete_title': 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
  'meta_connections_shopify-configuration_query-templates_table_popconfirn-delete_description': 'Cette action ne peut pas être annulée',
  'meta_connections_shopify-configuration_query-templates-form_title-create': 'Nouvelle requête',
  'meta_connections_shopify-configuration_query-templates-form_title-update': 'Modifier la requête :',
  'meta_connections_shopify-configuration_query-templates-form_template-name': 'Nom du modèle',
  'meta_connections_shopify-configuration_query-templates-form_template-name_required': 'Le nom du modèle est requis',
  'meta_connections_shopify-configuration_query-templates-form_queries': 'Requêtes',
  'meta_connections_shopify-configuration_query-templates-form_queries_required': 'Les requêtes sont requises',
  'meta_connections_shopify-configuration_query-templates-form_queries_placeholder': 'Sélectionnez les requêtes',
  'meta_connections_shopify-configuration_my-queries_title': 'Mes requêtes',
  'meta_connections_shopify-configuration_my-queries_table_created-at': 'Date de création',
  'meta_connections_shopify-configuration_my-queries_table_tag': 'Tag',
  'meta_connections_shopify-configuration_my-queries_table_description': 'Description',
  'meta_connections_shopify-configuration_my-queries_table_graphql-query': 'Requête GraphQL',
  'meta_connections_shopify-configuration_my-queries_table_delete-popconfirm_title': 'Êtes-vous sûr de vouloir supprimer cette requête ?',
  'meta_connections_shopify-configuration_my-queries_table_delete-popconfirm_description': 'Cette action ne peut pas être annulée',
  'meta_connections_shopify-configuration_query-form_title': 'Modifier la requête :',
  'meta_connections_shopify-configuration_query-form_query-name': 'Nom de la requête',
  'meta_connections_shopify-configuration_query-form_query-name_required': 'Le nom de la requête est requis',
  'meta_connections_shopify-configuration_query-form_description': 'Description',
  'meta_connections_shopify-configuration_query-form_description_required': 'La description est requise',
  'meta_connections_shopify-configuration_query-form_graphql-query': 'Requête GraphQL',
  'meta_connections_shopify-configuration_query-form_graphql-query_required': 'La requête est requise',
  'meta_connections_shopify-configuration_test-query_data-msg-1': 'Vous devez ajouter la requête',
  'meta_connections_shopify-configuration_test-query_data-msg-2': 'de Shop au connecteur de',
  'meta_connections_shopify-configuration_test-query_data-msg-3': 'Aucune connexion avec le connecteur',
  'meta_connections_shopify-configuration_test-query_data-msg-4': 'Aucune connexion avec Shopify',
  'meta_connections_shopify-configuration_test-query_title': 'Tester la requête',
  'meta_connections_shopify-configuration_test-query_btn-success': 'Enregistrer et tester',
  'meta_connections_shopify-configuration_edit-api-connection_title': 'Paramètres du connecteur de',
  'meta_connections_shopify-configuration_edit-api-connection_get-sample': 'Obtenir un exemple',
  'meta_connections_shopify-configuration_edit-api-connection_empty-sample': 'Aucune requête disponible pour ce connecteur.',
  'meta_connections_shopify-configuration_edit-api-connection_go-to-api-configuration': "Aller à la configuration de l'API de",
  'meta_connections_shopify-configuration_edit-api-connection_go-to-configuration': 'Aller à la configuration',
  'meta_connections_shopify-configuration_edit-api-connection_select-queries': 'Sélectionnez les requêtes que vous souhaitez exécuter sur le connecteur de',
  'meta_connections_shopify-configuration_field-table-list_title': 'Instructions de la carte',
  'meta_connections_shopify-configuration_field-table-list_delete-fields': 'Supprimer les instructions',
  'meta_connections_shopify-configuration_field-table-list_import-fields': 'Importer les instructions',
  'meta_connections_shopify-configuration_field-table-list_add-field': 'Ajouter une instruction',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_select-form': 'Sélectionnez le type de formulaire',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_select-field-type': "Sélectionnez le type d'instruction :",
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_title': "Supprimer l'instruction de la carte",
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_onOk': 'Supprimer de la carte',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_description-1': "Êtes-vous sûr de vouloir supprimer l'instruction",
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_description-2': 'de la carte ?',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_title': 'Importer les instructions',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_btn_import': 'Importer',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_my-queries-templates': "Mes modèles d'instructions",
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_emprty-templates': "Aucun modèle d'instructions",
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_go-to-fields': 'Aller aux instructions',
  'meta_connections_shopify-configuration_test-map_title': 'Tester la carte',
  'meta_connections_shopify-configuration_test-map_form_audience': 'Audience',
  'meta_connections_shopify-configuration_test-map_form_audience-placeholder': 'Sélectionnez une audience',
  'meta_connections_shopify-configuration_test-map_form_query': 'Sélectionnez une requête pour tester la cartographie',
  'meta_connections_shopify-configuration_test-map_form_query-response': 'Ou copiez le code que vous souhaitez mapper',
  'meta_connections_shopify-configuration_test-map_form_clean': 'Nettoyer',
  'meta_connections_shopify-configuration_test-map_form_test': 'Tester',
  'meta_connections_shopify-configuration_test-map_empty-results': 'Aucun résultat',
  'meta_connections_shopify-configuration_test-map_info': 'Informations :',
  'meta_connections_shopify-configuration_test-map_errors': 'Erreurs :',
  'meta_connections_shopify-configuration_test-map_result': 'Données résultantes :',
  'meta_connections_shopify-configuration_maps_title': 'Mes cartes',
  'meta_connections_shopify-configuration_maps_create-map-btn': 'Créer une carte',
  'meta_connections_shopify-configuration_maps_name': 'Nom',
  'meta_connections_shopify-configuration_maps_description': 'Description',
  'meta_connections_shopify-configuration_maps_audience': "Type d'audience",
  'meta_connections_shopify-configuration_maps_fields': "N° d'instructions",
  'meta_connections_shopify-configuration_maps_created-at': 'Date de création',
  'meta_connections_shopify-configuration_maps_delete_title': 'Êtes-vous sûr de vouloir supprimer cette carte ?',
  'meta_connections_shopify-configuration_maps_create-map_modal_title': 'Créer une carte',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_tag': 'Nom de la carte',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_description': 'Description de la carte',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_item-required': 'Ce champ est requis',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_audience': 'Audience',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_audience-placeholder': 'Sélectionnez une audience',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_submit-btn': 'Créer une carte',
  'meta_connections_map-fields-configuration_title': 'Paramètres des instructions',
  'meta_connections_map-fields-configuration_copy-fields-template': 'Copier',
  'meta_connections_map-fields-configuration_h4r-fields-templates_title': "Modèles d'instructions Hub4Retail",
  'meta_connections_map-fields-configuration_my-fields-templates_title': "Mes modèles d'instructions",
  'meta_connections_map-fields-configuration_my-fields-templates_empty-templates': "Aucun modèle d'instructions",
  'meta_connections_map-fields-configuration_my-fields-templates_popconfirn-delete-title': "Êtes-vous sûr de vouloir supprimer ce modèle d'instructions ?",
  'meta_connections_map-fields-configuration_my-fields_title': 'Mes instructions',
  'meta_connections_map-fields-configuration_my-fields_delete-selection': 'Supprimer la sélection',
  'meta_connections_map-fields-configuration_my-fields_delete-popconfirm-title': 'Êtes-vous sûr de vouloir supprimer cette instruction ?',
  'meta_table_connection-name': 'Nom de la connexion',
  'meta_table_last-update': 'Dernière mise à jour',
  'meta_table_last-connection': 'Dernière connexion',
  'meta_table_status': 'Statut',
  'meta_connections_modal_popover-title': 'Informations de connexion',
  'meta_connections_edit-info_title': 'Modifier les informations de connexion',
  'meta_connections_edit-configuration_title': 'Modifier les paramètres de connexion',
  'meta_connections_edit-map_title': 'Modifier les informations de la carte',
  'meta_connections_edit-map_form_tag': 'Nom de la carte',
  'meta_connections_edit-map_form_description': 'Description de la carte',
  'meta_connections_edit-map_form_required': 'Ce champ est requis',
  'meta_connections_edit-map_form_audience': 'Audience',
  'meta_connections_edit-map_form_audience-placeholder': 'Sélectionnez une audience',
  'meta_connections_edit-map_form_submit': 'Mettre à jour',
  'meta_connections_edit-info_btn-tooltip': 'Modifier la connexion',
  'meta_connections_remove-popover_title': 'Supprimer la connexion avec Shopify',
  'meta_connections_remove-popover_description': 'Êtes-vous sûr de vouloir supprimer la connexion avec Shopify ?',
  'meta_connections_edit-connection-mapping_title': 'Gérer les cartes de données à traiter',
  'meta_connections_edit-connection-mapping_select': 'Sélectionner le type de carte :',
  'meta_connections_edit-connection-mapping_select_catalog': 'Catalogue',
  'meta_connections_edit-connection-mapping_select_sale': 'Ventes',
  'meta_connections_modal_form_shopify_domain': 'Domaine',
  'meta_connections_modal_form_shopify_domain-required': 'Le domaine Shopify est requis',
  'meta_connections_modal_form_shopify_access-token': "Token d'accès",
  'meta_connections_modal_form_shopify_access-token-required': "Le token d'accès Shopify est requis",
  'meta_connections_modal_form_shopify_access-api-secret-key': "Clé secrète de l'API",
  'meta_connections_modal_form_shopify_access-api-secret-key-required': "La clé secrète de l'API Shopify est requise",
  'meta_connections_modal_form_shopify_steps_create-connection_title': 'Créer la connexion',
  'meta_connections_modal_form_shopify_steps_set-connection_title': 'Configurer la connexion',
  'meta_connections_modal_form_shopify_go-to-connections': 'Retour aux connexions',
  'meta_connections_modal_form_shopify_alert-success': "Connexion avec l'API Shopify établie.",
  'meta_connections_modal_form_shopify_alert-error': "Pas de connexion avec l'API Shopify, vérifiez les données et sauvegardez à nouveau la connexion.",
  'meta_connections_modal_form_prestashop_store-url': 'URL de la boutique',
  'meta_connections_modal_form_prestashop_store-url-required': "L'URL de la boutique Shopify est requise",
  'meta_connections_modal_form_prestashop_version': 'Version de Prestashop',
  'meta_connections_modal_form_prestashop_version-required': 'La version de Prestashop est requise',
  'meta_connections_modal_form_odoo_instance-url': "URL d'instance",
  'meta_connections_modal_form_odoo_instance-url-required': "L'URL de l'instance Odoo est requise",
  'meta_connections_modal_form_odoo_user-name': "Nom d'utilisateur",
  'meta_connections_modal_form_odoo_user-name-required': "Le nom d'utilisateur Odoo est requis",
  'meta_connections_modal_form_odoo_database-name': 'Nom de la base de données',
  'meta_connections_modal_form_odoo_database-name-required': 'Le nom de la base de données Odoo est requis',
  'meta_connections_api-connections_comming-soon': 'Bientôt disponible...',
  'meta_connections_create-new-connection_connection-type': 'Type de connexion :',
  'meta_connections_form-items_tag-form-item_label': 'Nom de la connexion',
  'meta_connections_form-items_tag-form-item_label-required': 'Veuillez entrer un nom',
  'meta_connections_modal_form_access-api-key': "Clé de l'API",
  'meta_connections_modal_form_access-api-key-required': "La clé de l'API Shopify est requise",
  'meta-connections_mapping-form_periodicity': 'Périodicité',
  'meta-connections_mapping-form_periodicity_required': 'La périodicité est requise',
  'meta-connections_mapping-form_periodicity_dairy': 'Quotidien',
  'meta-connections_mapping-form_periodicity_weekly': 'Hebdomadaire',
  'meta-connections_mapping-form_periodicity_biweekly': 'Bimensuel',
  'meta-connections_mapping-form_periodicity_monthly': 'Mensuel',
  'meta-connections_modal_input_btn-reset-form': 'Réinitialiser',
  'meta-connections_mapping-table_column-3_label': 'Données résultantes',
  'meta-connections_mapping-table_column-2_label': 'Colonnes du CSV',
  'meta-connections_mapping-table_column-2_select-label': 'Sélectionner une colonne',
  'meta-connections_mapping-table_column-2_select-label-multiple': 'Sélectionner une ou plusieurs colonnes',
  'meta-connections_mapping-table_column-2_select-format_label': 'Sélectionner un format',
  'meta-connections_delete-popconfirm_icon-tooltip': 'Supprimer la connexion',
  'meta_table_status_success': 'Actif',
  'meta_table_status_error': 'Erreur',
  'meta_connections_shopify.configuration-form_items_template-label': 'Modèles',
  'meta_connections_shopify.configuration-form_items_template-label-placeholder': 'Sélectionner un ou plusieurs modèles',
  'meta_connections_shopify.configuration-form_items_queries-label': 'Requêtes',
  'meta_connections_shopify.configuration-form_items_queries-check-all': 'Tout cocher',
  ///////////////////////////

  // ACTIONS ////////////////
  // Clients
  'clients_actions_add-client-success': 'Client créé avec succès',
  'clients_actions_update-client-success': 'Client mis à jour avec succès',
  'clients_actions_update-client-error': 'Erreur lors de la mise à jour du client',
  'clients_actions_client-exists': 'Le client existe déjà',
  'clients_actions_add-point-of-sale-success': 'Point de vente créé avec succès',
  'clients_actions_add-point-of-sale-error': 'Erreur lors de la création du point de vente',
  'clients_actions_update-point-of-sale-success': 'Point de vente mis à jour avec succès',
  'clients_actions_upgrade-point-of-sale-success': 'Point de vente mis à jour avec succès',
  'clients_actions_upgrade-points-of-sale-success': 'Points de vente mis à jour avec succès',
  'clients_actions_update-point-of-sale-error': 'Erreur lors de la mise à jour du point de vente',
  'action_points-of-sale_assign-point-of-sale-categories_error': 'Erreur lors de la mise à jour des catégories du point de vente',
  'clients_actions_remove-point-of-sale-success': 'Point de vente supprimé avec succès',
  'clients_actions_remove-point-of-sale-error': 'Erreur lors de la suppression du point de vente',
  'clients_actions_share-data-point-of-sale-success': 'Partage de données avec le point de vente',
  'clients_actions_dont-share-data-point-of-sale-success': 'Vous avez cessé de partager des données avec le point de vente',
  'clients_actions_association-success': 'Client associé avec succès',
  'clients_actions_association-error': "Erreur lors de l'association du client",
  'clients_actions_reject-association-success': 'Dissociation réussie',
  'clients_actions_reject-association-error': 'Erreur lors de la dissociation du client',
  'clients_actions_accept-ps-association-success': 'Point de vente lié avec succès',
  'clients_actions_accept-ps-association-error': 'Erreur lors de la dissociation du point de vente',
  'clients_actions_update-exchange-rate-error': 'Erreur de mise à jour du taux de change',
  'clients_actions_update-exchange-rate-success': 'Taux de change mis à jour avec succès',
  'clients_actions_update-exchange-rate-error-403': "Pour ajouter des taux de change, la devise de l'entreprise doit d'abord être ajoutée",
  'clients_actions_update-exchange-rate-error-404': "Le point de vente n'existe pas",
  // Commercial Profile
  'commercial-profile_actions_init-bio_error': 'Erreur lors de la récupération de la biographie',
  'commercial-profile_actions_update-bio_success': 'Biographie mise à jour avec succès',
  'commercial-profile_actions_update-bio_error': 'Erreur lors de la mise à jour de la biographie',
  // Catalog Correlation
  'catalog-correlation_assign-generics_success': 'Génériques attribués avec succès',
  'catalog-correlation_assign-generics_error': "Erreur lors de l'attribution des génériques",
  // Catalog CSV upload
  'catalog-csv-upload_publish-upload-success-1': 'Catalogue publié avec succès',
  'catalog-csv-upload_publish-upload-success-2': 'Catalogue masqué avec succès',
  'catalog-csv-upload_publish-upload-error-1': 'Erreur lors de la publication du catalogue',
  'catalog-csv-upload_publish-upload-error-2': 'Erreur lors du masquage du catalogue',
  'catalog-csv-upload_reject-upload-success': 'Le catalogue est en cours de suppression ; cela sera reflété sur la plateforme dans quelques minutes.',
  'catalog-csv-upload_reject-upload-error': 'Erreur lors de la suppression du catalogue',
  'catalog-csv-upload_set-start-season-date-success': 'Date de début de la saison mise à jour avec succès',
  'catalog-csv-upload_set-start-season-date-error': 'Erreur lors de la mise à jour de la date de début de la saison',
  'catalog-csv-upload_set-end-season-date-success': 'Date de fin de la saison mise à jour avec succès',
  'catalog-csv-upload_set-end-season-date-error': 'Erreur lors de la mise à jour de la date de fin de la saison',
  'catalog-csv-upload_enable-season-success-1': 'Saison activée avec succès',
  'catalog-csv-upload_enable-season-success-2': 'Saison désactivée avec succès',
  'catalog-csv-upload_enable-season-error-1': "Erreur lors de l'activation de la saison",
  'catalog-csv-upload_enable-season-error-2': 'Erreur lors de la désactivation de la saison',
  'catalog-csv-upload_get-mappings-error-1': 'Erreur lors de la récupération des clés de correspondance',
  'catalog-csv-upload_get-mappings-error-2': 'Erreur du serveur lors de la récupération des clés de correspondance',
  'catalog-csv-upload_delete-mapping-success': 'Correspondance supprimée avec succès',
  'catalog-csv-upload_delete-mapping-error': 'Erreur lors de la suppression de la correspondance',
  'catalog-csv-upload_create-mapping-success': 'Correspondance créée avec succès',
  'catalog-csv-upload_create-mapping-error': 'Erreur lors de la création de la correspondance',
  // Commercial profile
  'commercial-proile_actions_set-banner-action-success': 'Bannière mise à jour avec succès',
  'commercial-proile_actions_set-banner-action-error': 'Erreur lors de la mise à jour de la bannière',
  'commercial-proile_actions_set-banner-action-server-error': 'Erreur du serveur lors de la mise à jour de la bannière',
  'commercial-proile_actions_set-products-action-success': 'Produits mis à jour avec succès',
  'commercial-proile_actions_set-products-action-error': 'Erreur lors de la mise à jour des produits',
  'commercial-proile_actions_set-products-action-server-error': 'Erreur du serveur lors de la mise à jour des produits',
  'commercial-proile_actions_remove-product-action-error': 'Erreur lors de la suppression du produit',
  'commercial-proile_actions_remove-product-action-server-error': 'Erreur du serveur lors de la suppression du produit',
  'commercial-proile_actions_set-videos-action-success': 'Vidéos mises à jour avec succès',
  'commercial-proile_actions_set-videos-action-error': 'Erreur lors de la mise à jour des vidéos',
  'commercial-proile_actions_set-videos-action-server-error': 'Erreur du serveur lors de la mise à jour des vidéos',
  'commercial-proile_actions_remove-video-action-error': 'Erreur lors de la suppression de la vidéo',
  'commercial-proile_actions_remove-video-action-server-error': 'Erreur du serveur lors de la suppression de la vidéo',
  // Commercial agents
  'actions_commercial-agents_get-commercial-agents_error': 'Erreur lors de la récupération des agents commerciaux',
  'actions_commercial-agents_create-commercial-agent_success': 'Agent commercial créé avec succès',
  'actions_commercial-agents_create-commercial-agent_error': 'Erreur lors de la création de l’agent commercial',
  'actions_commercial-agents_assign-commercial-agent_error': 'Erreur lors de l’attribution du client à l’agent commercial',
  'actions_commercial-agents_unassign-commercial-agent_error': 'Erreur lors de la dissociation du client de l’agent commercial',
  'actions_commercial-agents_update-commercial-agent_success': 'Agent commercial mis à jour avec succès',
  'actions_commercial-agents_update-commercial-agent_error': 'Erreur lors de la mise à jour de l’agent commercial',
  'actions_commercial-agents_delete-commercial-agent_success': 'Agent commercial supprimé avec succès',
  'actions_commercial-agents_delete-commercial-agent_error': 'Erreur lors de la suppression de l’agent commercial',
  // Main contacts
  'actions_main-contacts_get-main-contacts_error': 'Erreur lors de la récupération des contacts principaux',
  'actions_main-contacts_create-main-contact_success': 'Contact créé avec succès',
  'actions_main-contacts_create-main-contact_error': 'Erreur lors de la création du contact',
  'actions_main-contacts_update-main-contact_success': 'Contact mis à jour avec succès',
  'actions_main-contacts_update-main-contact_error': 'Erreur lors de la mise à jour du contact',
  'actions_main-contacts_delete-main-contact_success': 'Contact supprimé avec succès',
  'actions_main-contacts_delete-main-contact_error': 'Erreur lors de la suppression du contact',
  // Brand users
  'actions_brand-users_get-brand-users_error': 'Erreur lors de la récupération des utilisateurs',
  'actions_brand-users_create-brand-user_success': 'Utilisateur créé avec succès',
  'actions_brand-users_create-brand-user_exists': "L'utilisateur existe déjà",
  'actions_brand-users_create-brand-user_error': 'Erreur lors de la création de l’utilisateur',
  'actions_brand-users_update-brand-user_success': 'Utilisateur mis à jour avec succès',
  'actions_brand-users_update-brand-user_error': 'Erreur lors de la mise à jour de l’utilisateur',
  'actions_brand-users_update-brand-user_rol-error': 'Erreur lors de la mise à jour du rôle de l’utilisateur',
  'actions_brand-users_update-brand-user_notifications-error': 'Erreur lors de la mise à jour des types de notifications',
  'actions_brand-users_delete-brand-user_success': 'Utilisateur supprimé avec succès',
  'actions_brand-users_delete-brand-user_error': 'Erreur lors de la suppression de l’utilisateur',
  // Sales matching
  'sales-matching_match-sale_success': 'Vente associée avec succès',
  'sales-matching_match-sale_error': 'Impossible d’associer la vente',
  'sales-matching_match-sale_premission-error': 'Vous n’avez pas la permission d’associer des ventes',
  'sales-matching_match-sale_client-product-id-not-found-error': "ID du produit client introuvable",
  // Catalog tarifs
  'actions_catalog-tarifs_create-tarif_success': 'Tarif créé avec succès',
  'actions_catalog-tarifs_create-tarif_error': 'Erreur lors de la création du tarif',
  'actions_catalog-tarifs_update-tarif_success': 'Tarif mis à jour avec succès',
  'actions_catalog-tarifs_update-tarif_error': 'Erreur lors de la mise à jour du tarif',
  'actions_catalog-tarifs_delete-tarif_success': 'Tarif supprimé avec succès',
  'actions_catalog-tarifs_delete-tarif_error': 'Erreur lors de la suppression du tarif',
  'actions_catalog-tarifs_download-tarif_success': 'Tarif téléchargé avec succès',
  'actions_catalog-tarifs_download-tarif_error': 'Erreur lors du téléchargement du tarif',
  'actions_catalog-tarifs_download-tarif_warning': 'Il n’y a pas de produits à télécharger',
  'actions_catalog-tarifs_get-tarif_error': 'Erreur lors de la récupération des tarifs',
  ///////////////////////////

  // SETTINGS PAGE ////////
  'settings-page_nav_chronos': 'Chronos',
  'settings-page_nav_devices': 'Dispositifs',
  'settings-page_nav_touch-screen': 'Écrans Tactiles',
  'settings-page_nav_users': 'Utilisateurs',
  'settings-page_nav_system-settings': 'Paramètres du Système',
  'settings-page_nav_commercial-profile': 'Profil Commercial de la Marque',
  'settings-page_nav_billing': 'Facturation',
  'settings-page_nav_support': 'Support',
  // Users page
  'settings-page_users-page_create-user-btn': 'Créer un utilisateur',
  // Meta
  'action_meta_get-connections_error': 'Erreur lors de la récupération des connexions',
  'action_meta_delete-connection_success': 'Connexion supprimée avec succès',
  'action_meta_delete-connection_error': 'Erreur lors de la suppression de la connexion',
  'action_meta_create-connection_success': 'Connexion créée avec succès',
  'action_meta_get-queries_error': 'Erreur lors de la récupération des requêtes',
  'action_meta_create-sftp-connection_error-403': "Le nom d'utilisateur existe déjà. Essayez un autre.",
  'action_meta_get-mapping-keys_error': 'Erreur lors de la récupération des clés de mappage',
  'action_meta_create-shopify-connection_error-409': 'Le domaine est déjà utilisé',
  'action_meta_create-shopify-connection_error': 'Erreur lors de la création de la connexion',
  'action_meta_update-connection_success': 'Connexion mise à jour avec succès',
  'action_meta_update-connection_error': 'Erreur lors de la mise à jour de la connexion',
  'action_meta_create-connection_error': 'Erreur lors de la création de la connexion',
  'settings-page_nav_meta': 'Meta',
  /////////////////////////

  // COMMERCIAL PROFILE ////////////
  'commercial-profile_title': 'Profil Commercial',
  'commercial-profile_btn-edit': 'Éditer',
  'commercial-profile_btn-save': 'Sauvegarder',
  'commercial-profile_banner_title': 'Télécharger une Bannière',
  'commercial-profile_banner_p-1': 'La bannière apparaîtra sur le profil commercial de votre marque pour la promouvoir et vous connecter avec les magasins multimarques.',
  'commercial-profile_banner_p-2': 'Téléchargez une bannière de 1800x200 px.',
  'commercial-profile_banner_p-3': 'Assurez-vous qu’elle soit de bonne qualité et attrayante pour attirer les magasins multimarques.',
  'commercial-profile_about-us_title': 'À Propos de Nous',
  'commercial-profile_about-us_p-1': 'Parlez un peu de votre marque pour attirer les magasins multimarques. Jusqu’à un maximum de 100 mots.',
  'commercial-profile_about-us_p-2': 'La description apparaîtra sur le profil commercial de votre marque pour la promouvoir et vous connecter avec les magasins multimarques.',
  'commercial-profile_our-products_title': 'Nos Produits',
  'commercial-profile_our-products_p': 'Sélectionnez 5-10 produits de votre dernière saison.',
  'commercial-profile_our-videos_title': 'Quelques-unes de nos vidéos...',
  'commercial-profile_our-videos_p': 'Sélectionnez 4 produits de votre dernière saison.',
  'commercial-profile_banner_modal_title': 'Sélectionner une bannière',
  'commercial-profile_modal_onOk': 'Accepter',
  'commercial-profile_modal_onCancel': 'Annuler',
  'commercial-profile_banner-title': 'Sélectionnez une bannière pour votre profil commercial',
  'commercial-profile_modal-content_banners-empty-msg': "Il n'y a pas encore de bannières.",
  'commercial-profile_modal-content_navigate-banners-btn': 'Aller aux bannières multimédia',
  'commercial-profile_modal-content_videos-empty-msg': "Il n'y a pas encore de vidéos.",
  'commercial-profile_modal-content_navigate-videos-btn': 'Aller aux vidéos multimédia',
  'commercial-profile_our-products_modal_title': 'Sélectionner des produits',
  'commercial-profile_our-products_modal_max-items-msg': 'Vous ne pouvez sélectionner que 10 produits.',
  'commercial-profile_our-products_modal_see-more-btn': 'Voir plus',
  'commercial-profile_our-videos_modal_title': 'Sélectionner des vidéos',
  'commercial-profile_our-videos_modal_max-items-msg': 'Vous ne pouvez sélectionner que 4 vidéos.',
  'commercial-profile_search-input-placeholder_fr': 'Rechercher par nom ou code',
  //////////////////////////////////

  // SALES MATCHING ///////////////////////////////////////////////
  'sales-matching_columns_search-on': 'Chercher dans',
  'sales-matching_columns_operator_contains': 'Contient',
  'sales-matching_columns_operator_ends-with': 'Se termine par',
  'sales-matching_columns_operator_starts-with': 'Commence par',
  'sales-matching_columns_operator_equals': 'Égal',
  'sales-matching_columns_operator_not-equals': 'Pas égal',
  'sales-matching_columns_operator_in': 'Avec',
  'sales-matching_columns_operator_not-in': 'Sans',
  'sales-matching_columns_operator_greater-than': 'Supérieur à',
  'sales-matching_columns_operator_less-than': 'Inférieur à',
  'sales-matching_columns_operator_is-null': 'Est vide',
  'sales-matching_columns_operator_is-not-null': 'N’est pas vide',
  'sales-matching_columns_column-search_search': 'Chercher',
  'sales-matching_columns_column-search_reset': 'Réinitialiser',
  'sales-matching_columns_column-search_close': 'Fermer',
  'sales-matching_confirm-match': 'Êtes-vous sûr de vouloir enregistrer les modifications ?',
  /////////////////////////////////////////////////////////////////

  // CATALOG TARIFS /////////////////////////////
  'catalog-tarifs_list_add-tarif': 'Ajouter un tarif',
  'catalog-tarifs_list_upload-tarif_csv-allowed': 'Seuls les fichiers CSV sont autorisés',
  'catalog-tarifs_list_upload-tarif_error': 'Erreur lors de la lecture du fichier',
  'catalog-tarifs_list_upload-modal-title': 'Téléverser des tarifs',
  'catalog-tarifs_list_upload-modal_download-csv': 'Télécharger le CSV de tous les produits',
  'catalog-tarifs_list_upload-modal_download-pending-products-csv': 'Télécharger le CSV des produits sans tarif',
  'catalog-tarifs_list_upload-modal_upload-csv': 'Importer un CSV',
  'catalog-tarifs_list_create-modal_create-title': 'Créer un nouveau tarif',
  'catalog-tarifs_list_create-modal_update-title': 'Modifier le tarif',
  'catalog-tarifs_list_create-modal_form_code-label': 'Code tarif',
  'catalog-tarifs_list_create-modal_form_code_required': 'Le code tarif est obligatoire',
  'catalog-tarifs_list_create-modal_form_description-label': 'Description du tarif',
  'catalog-tarifs_list_create-modal_form_description_required': 'La description du tarif est obligatoire',
  'catalog-tarifs_list_create-modal_form_clients-label': 'Clients',
  'catalog-tarifs_table_code': 'Code tarif',
  'catalog-tarifs_table_description': 'Description du tarif',
  'catalog-tarifs_table_currency': 'Devise',
  'catalog-tarifs_table_clients': 'Clients',
  'catalog-tarifs_table_products-with-tarifs': 'Produits avec tarif',
  'catalog-tarifs_table_products-without-tarifs': 'Produits sans tarif',
  'catalog-tarifs_table_actions_upload-tarifs': 'Téléverser des tarifs',
  'catalog-tarifs_table_actions_edit-tarif-tooltip': 'Modifier le tarif',
  'catalog-tarifs_table_actions_see-tarif-tooltip': 'Voir le tarif',
  'catalog-tarifs_table_actions_delete-tarif-tooltip': 'Supprimer le tarif',
  'catalog-tarifs_table_actions_delete-tarif-popconfirm': 'Êtes-vous sûr de vouloir supprimer ce tarif ?',
  'catalog-tarifs_table_actions_see-tarif-title': 'Voir les tarifs de',
  'catalog-tarifs_table_see-tarif_product-description': 'Description du produit',
  'catalog-tarifs_table_see-tarif_ean': 'EAN',
  'catalog-tarifs_table_see-tarif_reference': 'Référence',
  'catalog-tarifs_table_see-tarif_color-description': 'Description de la couleur',
  'catalog-tarifs_table_see-tarif_color-code': 'Code couleur',
  'catalog-tarifs_table_see-tarif_size': 'Taille',
  'catalog-tarifs_table_see-tarif_pvi': 'PVR',
  'catalog-tarifs_table_see-tarif_pvpr': 'PDSF',
  'catalog-tarifs_reload-tarifs': 'Recharger',
  'catalog-tarifs_history_table_title': 'Historique des téléchargements',
  'catalog-tarifs_history_table_createdAt': 'Date de téléchargement',
  'catalog-tarifs_history_table_insert': 'Inséré',
  'catalog-tarifs_history_table_update': 'Mis à jour',
  'catalog-tarifs_history_table_not_found': 'Non trouvé',
  'catalog-tarifs_history_table_eans_not_found': 'Télécharger les EANs non trouvés',
  'catalog-tarifs_history_table_with_no_tarif': 'Produits sans tarif',
  'catalog-tarifs_history_table_error': 'Erreur',
  'catalog-tarifs_history_table_tarif_file-confirmed': 'Fichier confirmé',
  'catalog-tarifs_history_table_tarif_file-processed': 'Fichier traité',
  'catalog-tarifs_history_table_tarif_file-error': 'Erreur de fichier',
  ///////////////////////////////////////////////

  // NOTIFICATIONS /////////////////
  // Notifications Page
  'notifications-page_notifications-title': 'Notifications',
  'notifications-page_alerts-title': 'Alertes',
  'notifications_btn-name_catalog': 'Voir le Catalogue',
  'notifications_btn-name_profile': 'Voir le Profil',
  'notifications_list_show-all': 'Tout',
  'notifications_list_show-unreaded': 'Non lus',
  'notifications_list_per-page-select': 'par page',
  // Popover
  'notifications_popover_title': 'NOTIFICATIONS',
  'notifications_popover_empty-notifications': 'Pas de notifications',
  'notifications_popover_btn-name_catalog': 'Voir le Catalogue',
  'notifications_popover_btn-name_profile': 'Voir le Profil',
  'notifications_popover_item_mark-as-readed_msg': 'Marqué comme lu',
  'notifications_popover_item_mark-as-unreaded_msg': 'Marqué comme non lu',
  'notifications_popover_item_mark-as-readed': 'Marquer comme lu',
  'notifications_popover_item_mark-as-unreaded': 'Marquer comme non lu',
  'notifications_popover_all-notifications-btn': 'Toutes les notifications',
  'notifications_popover_accept': 'Accepter',
  'notifications_popover_reject': 'Rejeter',
  'notifications_popover_pending_fr': 'En attente',
  'alerts_popover_title': 'ALERTES',
  'alerts_popover_empty-notifications': "Pas d'alertes",
  'alerts_popover_all-notifications-btn': 'Toutes les alertes',
  ///////////////////////////////////

  // WHOLESALE FEED /////////////////
  'wholesale-feed_info_title': 'Informations Générales',
  'wholesale-feed_info_city': 'Ville',
  'wholesale-feed_info_province': 'Province',
  'wholesale-feed_main-contact_title': 'Contact Principal',
  'wholesale-feed_main-contact_name': 'Nom',
  'wholesale-feed_main-contact_email': 'E-mail',
  'wholesale-feed_main-contact_phone-number': 'Numéro de Téléphone',
  'wholesale-feed_main-contact_sector': 'Secteur',
  'wholesale-feed_points-of-sale_title': 'Points de Vente',
  'wholesale-feed_working-brands_title': 'Marques Commercialisées',
  ///////////////////////////////////

  // MESSAGE PAGES //////////
  // Error
  'errors-page_404_subtitle': "Désolé, la page que vous recherchez n'existe pas.",
  'errors-page_404_btn-go-back': 'Retourner',
  // Coming soon
  'coming-soon-page_title': 'Bientôt disponible!',
  'coming-soon-page_go-back': 'Retour',
  /////////////////////////

  // BREADCRUMBS ///////////////
  'breadcrumbs_multimedia': 'Multimédia',
  'breadcrumbs_multimedia-videos': 'Vidéos',
  'breadcrumbs_multimedia-images': 'Images',
  'catalog_breadcrumb_item1': 'Catalogue',
  'catalog_breadcrumb_item2': 'Voir le catalogue',
  'breadcrumbs_multimedia-banners': 'Bannières',
  'catalog-uploads_breadcrumb': 'Téléversement de catalogues',
  'catalog-uploads_handle-images_breadcrumb': 'Gestion des images',
  'breadcrumb_catalog-download': 'Télécharger le catalogue',
  'breadcrumb_catalog-update-references': 'Mettre à jour les références',
  'catalog-uploads-preview_breadcrumb': 'Aperçu',
  'add-catalog_breadcrumb': 'Ajouter un catalogue',
  'catalog_correlation': 'Corrélation de références',
  'catalog_generic': 'Génériques H4R',
  'breadcrumb_catalog_tarifs': 'Tarifs',
  // Clients
  'breadcrumbs_clients': 'Clients',
  'breadcrumbs_clients-list': 'Liste des clients',
  'breadcrumbs_add-client': 'Ajouter un client',
  'breadcrumbs_resume': 'Résumé',
  'breadcrumbs_main-contacts': 'Contacts',
  'breadcrumbs_sale-points': 'Points de vente',
  'breadcrumbs_brands-sold': 'Marques vendues',
  // Account
  'breadcrumbs_account': 'Compte',
  'breadcrumbs_account_profile': 'Profil',
  'breadcrumbs_account_company': "Informations sur l'entreprise",
  'breadcrumbs_account_contacts': 'Contacts Principaux',
  'breadcrumbs_account_commercial-agents': 'Agents Commerciaux',
  // Settings
  'breadcrumbs_settings': 'Paramètres',
  'breadcrumbs_commercial-profile': 'Profil Commercial',
  // Meta
  'breadcrumbs_meta_edit_connetion': 'Modifier la connexion',
  'breadcrumbs_meta_map_list': 'Cartes',
  'breadcrumbs_meta_edit_map': 'Modifier la carte',
  'breadcrumbs_meta_fields-configuration': 'Paramètres des instructions',
  // Sales
  'breadcrumbs_sales': 'Ventes',
  //////////////////////////////

  // MODALS ///////////////////
  'modal_email-verified_title': 'Vérifiez votre e-mail',
  'modal_email-verified_content': 'Pour continuer le processus, veuillez vérifier votre e-mail.',
  'modal_email-verified_content-1': "Vérifiez l'adresse à partir du lien reçu par email, puis cliquez sur",
  'modal_email-verified_content_btn_resend': 'Renvoyer la vérification',
  'modal_email-verified_content_btn_reload': 'Recharger',
  'modal_email-verified_content_notif_resend_title_success': 'E-mail de vérification renvoyé avec succès.',
  'modal_email-verified_content_notif_resend_title_error': 'Une erreur s’est produite lors du renvoi de l’e-mail de vérification.',
  'modal_email-verified_content_notif_resend_title': 'Notification de renvoi',
  'modal_email-verified_content_notif_resend_content-1': "L'email de vérification a été envoyé à cette adresse",
  'modal_email-verified_content_notif_resend_content-2': 'Vérifiez votre email pour continuer.',
  /////////////////////////////

  // POLICY PRIVACY //////////
  'policy-privacy-modal_title': "Conditions d'utilisation",
  'policy-privacy-modal_btn-accept': 'Accepter',
  'policy-privacy-modal_btn-cancel': 'Annuler',
  'policy-privacy-modal_checkbox': "J'accepte les Conditions d'utilisation",
  'policy-privacy-modal_checkbox-message': 'Acceptez la politique de confidentialité et les conditions.',
  ////////////////////////////

  // SERVER DOWN MODAL /////
  'server-down-modal_title': 'Erreur du serveur',
  'server-down-modal_content': 'Nous rencontrons des problèmes avec nos services. Veuillez réessayer plus tard ou contacter le support technique.',
  //////////////////////////

  // CHANGE DEFAULT PASSWORD MODAL /////////////////
  'change-default-password-modal_title': 'Changez le mot de passe pour continuer',
  'change-default-password_error-1': 'Erreur lors du changement du mot de passe',
  'change-default-password_error-2': 'Erreur lors de la mise à jour de l’utilisateur',
  'change-default-password_error-3': 'Erreur du serveur',
  //////////////////////////////////////////////////

  // NOTIFICATIONS /////////
  'notification-error_message': "Code d'erreur",
  'notification-error_description': "Veuillez réessayer plus tard. Si le problème persiste, contactez Hub4Retail et fournissez le code d'erreur.",
  //////////////////////////

  // NOTIFICATIONS TYPES /////////
  'notifications_type_catalog_wh-upload-sales-reminder': 'Rappel de téléchargement des ventes multimarques',
  'notifications_type_catalog_wh-first-upload-sales-reminder': 'Premier téléchargement de ventes',
  'notifications_type_catalog_br-accepts-request': 'La marque a accepté la demande d’association',
  'notifications_type_catalog_file-error': 'Erreur de fichier',
  'notifications_type_catalog_file-success': 'Fichier traité',
  'notifications_type_catalog_wh-point-of-sale-associated': 'Point de vente associé',
  'notifications_type_catalog_wh-request-association': 'Le client demande une association',
  'notifications_type_catalog_wh-pos-map-reminder': 'Rappel de cartographie des points de vente',
  ////////////////////////////////

  // GOOGLE ADDRESS FORM //////
  'google-address-form_address': 'Adresse',
  'google-address-form_floor': 'Étage',
  'google-address-form_door': 'Porte',
  'google-address-form_postal-code': 'Code postal',
  'google-address-form_city': 'Ville',
  'google-address-form_province': 'Province',
  'google-address-form_country': 'Pays',
  'google-address-form_select-country': 'Sélectionnez un pays',
  /////////////////////////////

  // CSV MAPPING FIELDS //////
  'csv-mapping-feld__product_description': 'Description du produit',
  'csv-mapping-feld__reference': 'Référence',
  'csv-mapping-feld__color': 'Couleur',
  'csv-mapping-feld__season': 'Saison',
  'csv-mapping-feld__ean': 'EAN',
  'csv-mapping-feld__gender': 'Genre',
  'csv-mapping-feld__material': 'Composition',
  'csv-mapping-feld__segmentation': 'Segmentation',
  'csv-mapping-feld__family': 'Famille',
  'csv-mapping-feld__division': 'Division',
  'csv-mapping-feld__tier': 'Segmentation de catalogue (Tier)',
  'csv-mapping-feld__color_description': 'Description de la couleur',
  'csv-mapping-feld__pvi': 'WHP (Prix de gros)',
  'csv-mapping-feld__pvpr': 'PVP (Prix de vente conseillé)',
  'csv-mapping-feld__size': 'Taille',
  'csv-mapping-feld__tags': 'Étiquettes',
  /////////////////////////////

  // LANGUAGES /////////////////
  'spanish-lang': 'Espagnol',
  'english-lang': 'Anglais',
  'french-lang': 'Français',
  'italian-lang': 'Italien',
  ////////////////////////////

  // SHARED //////////////////
  'settings': 'Paramètres',
  'logout': 'Déconnexion',
  'admin-panel_link': "Panneau d'administration",
  'see-more': 'Voir plus',
  'see-less': 'Voir moins',
  'see-all': 'Voir tout',
  'btn-save': 'Enregistrer',
  'edit-btn-label': 'Éditer',
  'delete-btn-label': 'Supprimer',
  'btn-cancel': 'Annuler',
  'see-more-content-button': 'Voir plus',
  'never-label': 'Jamais',
  'clean-form': 'Effacer le formulaire',
  'reset-btn': 'Réinitialiser',
  'reset-next': 'Suivant',
  'btn-next': 'Suivant',
  'send-btn': 'Envoyer',
  'not-authorized-warning': 'Vous n’avez pas la permission d’effectuer cette action',
  'form-label_role': 'Rôle',
  'form-label_language': 'Langue',
  ////////////////////////////
};

export default franceTranslation;
